module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc) {
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm);
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nfor (var i = 0; i < data.length; i++) {\n\n    var carouselItem = data[i];\n\n    var _uuid = Math.floor((Math.random() * 1000000) + 1);\n    var title = '';\n    if(carouselItem.title){\n        title = carouselItem.title;\n    }else if(carouselItem.alt){\n        title = carouselItem.alt;\n    }\n\n    var phatomTitle = title;\n\n    if(carouselItem.dataTracking){\n        var splittedTracking = carouselItem.dataTracking.split('|');\n        phatomTitle = splittedTracking[0];\n    }\n\n    var id;\n    if(carouselItem.id || carouselItem.id === 0){\n        id = carouselItem.id\n    }else{\n        id = carouselItem.contentId\n    }\n\n    var contentType = 'show';\n\n    if(carouselItem.contentType){\n        contentType = carouselItem.contentType;\n    }\n\n    if(carouselItem.isMovie){\n        contentType = 'movie';\n    }\n \n    var impressionContentType = contentType;\n    if(carouselItem.isOnNow){\n        impressionContentType = carouselItem.streamType;\n    }\n\n    if (carouselItem.showSeasonless && carouselItem.showEpisodeless && carouselItem.isCollectionCarousel) {\n        carouselItem.startDateISOClass = 'meta-airdate-left';\n        carouselItem.metaSeasonNumberClass = 'hide';\n        carouselItem.metaEpisodeNumberClass = 'hide';\n    } else {\n        carouselItem.startDateISOClass = '';\n        carouselItem.metaSeasonNumberClass = '';\n        carouselItem.metaEpisodeNumberClass = '';\n    }\n\n    if ((carouselItem.locked || carouselItem.bundleLocked) && carouselItem.isUserSubscriber && !carouselItem.addToMyListContentId) {\n        if(carouselItem.orientation == 'portrait'){\n            carouselItem.lockIconClass = 'bundle-lock portrait';\n        }else{\n            carouselItem.lockIconClass = 'bundle-lock';\n        }\n        \n        carouselItem.lockGradientClass = 'bundle-lock-gradient';\n    }\n\n    var cmsId = '';\n    if(carouselItem.cmsId) {\n        cmsId = carouselItem.cmsId;\n    }\n\n    var linkClasses = '';\n    if(carouselItem.status === 'PREMIUM' && !carouselItem.isUserSubscriber) {\n        linkClasses += ' subscribe';\n    }\n\n    if (typeof zoomCarouselEffectClass === 'string' && zoomCarouselEffectClass && !carouselItem.promoTile) {\n        linkClasses += ' ';\n        linkClasses += zoomCarouselEffectClass;\n    }\n    \n    if(carouselItem?.hasContentHighlight == true) {\n        linkClasses += ' content-highlight-enabled';\n    }\n\n    var linkClass = '';\n\n    if (carouselItem.hasNumberLabel) {\n        linkClass += 'numeric-link';\n    }\n\n    var ctaText = carouselItem.button?.label ?? \"\";\n%>\n\n    <% if(carouselItem) { %>\n\n        <a class=\"link <%= linkClass %> <%= (carouselItem.status === 'PREMIUM' && !carouselItem.isUserSubscriber)?'subscribe':'' %> <%= linkClasses %>\"\n        aria-label=\"<% if(title) { %><%= title %><% } %>\"\n        <% if(carouselItem.titleSlug) { %>\n        aria-describedby=\"<%= carouselItem.titleSlug %>-content\"\n        <% } %>\n        <% if(ctaText) { %>\n        data-cta=\"<%= ctaText %>\"\n        <% } %>\n        <% if(id !== null ) { %>\n        id=\"<%= id %>\"\n        <% } %>\n        <% if(carouselItem.genre) { %>\n        data-genre=\"<%= carouselItem.genre %>\"\n        <% } %>\n        <% if(carouselItem.showGenre) { %>\n        data-genre=\"<%= carouselItem.showGenre %>\"\n        <% } %>\n        <% if(carouselItem.href !== '') { %>\n        href=\"<%= carouselItem.href %>\"\n        <% } %>\n        <% if(carouselItem.actionTarget !== '') { %>\n        target=\"<%= carouselItem.actionTarget %>\"\n        <% } %>\n        <% if(title !== '') { %>\n        title=\"<%= title %>\"\n        <% } %>\n        <% if(carouselItem.aaLink !== '') { %>\n        aa-link=\"<%= carouselItem.aaLink %>\"\n        <% } %>\n        <% if(carouselItem.dataTracking) { %>\n        data-tracking=\"<%= carouselItem.dataTracking %>\"\n        <% } %>\n        <% if(carouselItem.content_id) { %>\n        vilynx-id=\"<%=carouselItem.content_id%>\"\n        <% } %>\n        <% if (typeof carouselItem.contentId !== 'undefined') { %>\n        vilynx-id=\"<%=carouselItem.contentId%>\"\n        <% } %>\n        <% if (carouselItem.promoTile) { %>\n        data-fathom = '<%=carouselItem.hubId%>||<%=i%>|promo_<%=carouselItem.contentType%>||<%=carouselItem.title%>||'\n        data-impression = '<%=carouselItem.hubId%>||<%=i%>|promo_<%=carouselItem.contentType%>||<%=carouselItem.title%>|||||'\n        <% } else { %>\n        data-fathom = '<%=carouselItem.contentIdFathom%>|getdisplayIDAbove|<%=i%>|<%=contentType%>|<%=carouselItem.recoId%>|<%=phatomTitle%>|<%=carouselItem.rankModel%>|<%=carouselItem.pvrModel%>'\n        data-impression = '<%=carouselItem.contentIdFathom%>|getdisplayIDAbove|<%=i%>|<%=impressionContentType%>|<%=carouselItem.recoId%>|<%=phatomTitle%>|<%=carouselItem.rankModel%>|<%=carouselItem.pvrModel%>|<%=carouselItem.badgeLabel%>|<%=carouselItem.bundleLocked%>|<%=cmsId%>'\n        <% } %>\n        >\n\n        <% omitTitle = false; %>\n        <% showDuration = false; %>\n\n            <%// VIDEOCONFIG CAROUSEL %>\n            <% if(typeof model !== 'undefined' && model === 'videoConfig') { %>\n\n                <div class=\"thumb-wrapper <% if(carouselItem.onNowTitle) { %>always-on<% } %>\"  style=\"background-image: linear-gradient(240deg, #<%= carouselItem.startHexColor %>, #<%= carouselItem.endHexColor %>)\">\n                \n                    <% if(!carouselItem.characterImage) { %>\n                        <img class=\"thumb lazy\"\n                        <% if(carouselItem.thumb) { %>\n                            data-src=\"<%= carouselItem.thumb %>\"\n                        <% } %>\n                        <% if(carouselItem.alt) { %>\n                            alt=\"<%= carouselItem.alt %>\"\n                        <% } %>\n                        >\n                    <% } %>\n                \n                    <%// Progress Bar %>\n                    <% if(carouselItem.progress && carouselItem.progress > 0) { %>\n                        <%\n                        var progress = carouselItem.progress;\n                        %>\n                        <%# %>\n<%# You must set _uuid & progress before including this file %>\n<%# hasRendered should also be set to true during browser resize before this tpl is rendered again, see gridView.js %>\n<%# %>\n<% if (typeof _uuid !== 'undefined' && typeof progress !== 'undefined') { %>\n<style>\n\n    #progress-bar-<%= _uuid %> {\n        width: 100%;\n        height: 4px;\n        border-radius: 10px;\n        background-color: rgba(255, 255, 255, 0.5);\n    }\n\n    #progress-bar-<%= _uuid %> .bar {\n        background-color: transparent;\n        background-image: -webkit-linear-gradient(135deg, #FFFFFF, #FFFFFF);\n        background-image: linear-gradient(135deg, #FFFFFF, #FFFFFF);\n        height: 4px;\n        border-radius: 10px 0 0 10px;\n        width: 0;\n\n        -webkit-animation: slideProgress-<%= _uuid %> ease-in 1;\n        call our keyframe named fadeIn, use animattion ease-in and repeat it only 1 time\n        -moz-animation: slideProgress-<%= _uuid %> ease-in 1;\n        animation: slideProgress-<%= _uuid %> ease-in 1s;\n        -webkit-animation-fill-mode: forwards;\n\n        <%# /* this makes sure that after animation is done we remain at the last keyframe value (opacity: 1)*/ %>\n        -moz-animation-fill-mode: forwards;\n        animation-fill-mode: forwards;\n        -webkit-animation-duration: 2s;\n        -moz-animation-duration: 2s;\n        animation-duration: 2s;\n    }\n\n    #progress-bar-<%= _uuid %> .bar.hasRendered {\n        -webkit-animation-duration: 0s;\n        -moz-animation-duration: 0s;\n        animation-duration: 0s;\n    }\n\n    @-webkit-keyframes slideProgress-<%= _uuid %> {\n        from {\n            width: 0;}\n\n        to {\n            width: <%= progress %>%;\n        }\n    }\n\n    @-moz-keyframes slideProgress-<%= _uuid %> {\n        from {\n            width: 0;\n        }\n        to {\n            width: <%= progress %>%;\n        }\n    }\n\n    @keyframes slideProgress-<%= _uuid %> {\n        from {\n            width: 0;\n        }\n        to {\n            width: <%= progress %>%;\n        }\n    }\n\n</style>\n\n<div class=\"progress-bar\" id=\"progress-bar-<%= _uuid %>\" data-percentage=\"<%= progress %>\">\n    <div class=\"bar<% if (typeof hasRendered !== 'undefined' && hasRendered) { %> hasRendered <% } %>\"></div>\n</div>\n<% } %>\n                    <% } %>\n                \n                    <% if(carouselItem.characterImage) { %>\n                        <img class=\"thumb lazy character-img\" data-src=\"<%= carouselItem.characterImage %>\" src=\"<%= carouselItem.characterImage %>\" alt=\"<%= carouselItem.title %>\">\n                    <% } %>\n                \n                    <% if(carouselItem.background) { %>\n                        <img class=\"brand-bkgd-static\" src=\"<%= carouselItem.background %>\" <% if(carouselItem.fallbackBackground) { %>onerror=\"this.onerror=null; this.src='<%= carouselItem.fallbackBackground %>'\"<% } %>>\n                    <% } %>\n                \n                    <% if(carouselItem.isUserSubscriber && carouselItem.bundleLocked) { %>\n                        <div class=\"<%= carouselItem.lockGradientClass %>\"></div>\n                    <% } %>\n                \n                    <% if (carouselItem.isUserSubscriber && !carouselItem.isUserRegistered && !carouselItem.addToMyListContentId && (carouselItem.locked || carouselItem.bundleLocked)) { %>\n                        <% if (!carouselItem.onNowTitle) { %>\n                            <div class=\"label <%= carouselItem.lockIconClass %>\"><img src=\"<%= carouselItem.lockIcon %>\"/></div>\n                        <% } %>\n                    <% } else if(carouselItem.icon) { %>\n                        <div class=\"label <%= carouselItem.icon %> circle-sm\"></div>\n                    <% } else if(carouselItem.status === 'PREMIUM' && !carouselItem.isUserSubscriber) { %>\n                        <div class=\"subscribe-gradient\"></div>\n                        <% if (typeof kidsContentLabel === \"undefined\" || kidsContentLabel === null) { %>\n                            <div class=\"label subscribe\"><%= getLocale('subscribe') %></div>\n                        <% } else { %>\n                            <div class=\"label subscribe\"><%= kidsContentLabel %></div>\n                        <% } %>\n                    <% } else if(carouselItem.status === 'AVAILABLE') { %>\n                        <div class=\"play label circle-sm\">\n                            <% if(carouselItem.content_id) { %>\n                                <svg class=\"svg-loader\" viewbox=\"0 0 33.83098862 33.83098862\" width=\"30\" height=\"30\"\n                                     xmlns=\"http://www.w3.org/2000/svg\">\n                                    <circle class=\"svg-loader__circle\" stroke=\"#FFFFFF\" stroke-width=\"2\" stroke-dasharray=\"100\" fill=\"none\"\n                                            cx=\"16.91549431\" cy=\"16.91549431\" r=\"15.91549431\"/>\n                                </svg>\n                            <% } %>\n                        </div>\n                    <% } %>\n                </div>\n                \n                <div class=\"info-wrapper\">\n                <%// META DATA %>\n                <% if(!carouselItem.isMovie && carouselItem.mediaType !== \"Movie\" && carouselItem.mediaType !== \"Standalone\" && carouselItem.mediaType !== \"Live\" && carouselItem.mediaType !== \"Clip\" && carouselItem.mediaType !== \"Trailer\") { %>\n\n                    <div class=\"meta-gray-wrapper\">\n                    <% //Shows %>\n                    <% if(!carouselItem.isSeasonless && !carouselItem.showSeasonless && carouselItem.seasonNumber) { %>\n                        <span class=\"meta-white\">\n                            <abbr aria-label=\"Season <%= carouselItem.seasonNumber %>\" title=\"<%= getLocale('season') %> <%= carouselItem.seasonNumber %>\">\n                                <%= getLocale('season_number_abbr', {'seasonNumber': carouselItem.seasonNumber }) %>\n                            </abbr>\n                        </span>\n                    <% } %>\n                    <% if(!carouselItem.isEpisodeless && !carouselItem.showEpisodeless && carouselItem.episodeNumber) { %>\n                        <span class=\"meta-white\">\n                            <abbr aria-label=\"Episode <%= carouselItem.episodeNumber %>\" title=\"<%= getLocale('episode') %> <%= carouselItem.episodeNumber %>\">\n                                <%= getLocale('episode_number_abbr', {'episodeNum': carouselItem.episodeNumber }) %>\n                            </abbr>\n                        </span>\n                    <% } %>\n                    \n                    <% if(displayShowTitle) { %>\n                        <span class=\"meta-gray\">\n                            <%= carouselItem.title %>\n                        </span>\n                    <% } else if(carouselItem.airDate !== 0 && carouselItem.chAirDate) { %>\n                        <span class=\"meta-gray meta-airdate\">\n                            <time datetime=\"<%= carouselItem.startDateISO %>\">\n                                <%= carouselItem.chAirDate %>\n                            </time>\n                        </span>\n                    <% } %>\n                    </div>\n                \n                    <div class=\"title-wrapper\">\n                        <div class=\"title\" data-title=\"<%= carouselItem.title %>\">\n                            <% if(displayShowTitle && carouselItem.seriesTitle) { %>\n                                <%= carouselItem.seriesTitle %>\n                            <% } else { %>\n                                <%= carouselItem.title %>\n                            <% } %>\n                        </div>\n                    </div>\n                \n                    <% } else { %>\n                        <% //Movie, CLIP, TRAILER, or LIVE Part %>\n                        <% if(carouselItem.mediaType === \"Movie\" || carouselItem.mediaType === \"Standalone\") { %>\n                            <div class=\"title-wrapper\">\n                                <div class=\"title\" data-title=\"<%= carouselItem.title %>\">\n                                    <%= carouselItem.title %>\n                                </div>\n                            </div>\n                        <% } else if(carouselItem.mediaType === \"Clip\" || carouselItem.mediaType === \"Trailer\") { %>\n                            <div class=\"meta-gray-wrapper\">\n                            <% if(carouselItem.duration) { %>\n                                <span class=\"meta-gray\">\n                                    <%= carouselItem.duration %>\n                                </span>\n                            <% } %>\n                            <% if(displayShowTitle) { %>\n                                <span class=\"meta-gray\">\n                                    <%= carouselItem.showOrMovieTitle  %>\n                                </span>\n                            <% } %>\n                            </div>\n                        <div class=\"title-wrapper\">\n                            <div class=\"title\" data-title=\"<%= carouselItem.label %>\">\n                                <%= carouselItem.label %>\n                            </div>\n                        </div>\n                    <% } %>\n                <% //No Meta Data for Live %>\n                <% } %>\n                </div>\n\n            <%// DEFAULT CAROUSEL %>\n            <% } else { %>\n\n                <% if(carouselItem.titleSlug) { %>\n                    <span class=\"aria-item-content\" id=\"<%= carouselItem.titleSlug %>-content\">\n                        <%= carouselItem.about %>\n                    </span>\n                <% } %>\n\n                <% if (carouselItem.hasNumberLabel) { %>\n                <div class=\"numeric-container <% if (carouselItem.numberLabel > 9) { %>double-digit<% } %>\">\n                    <div class=\"text-stroke\" data-text=\"<%= carouselItem.numberLabel %>\"><%= carouselItem.numberLabel %></div>\n                </div>\n                <% } %>\n\n                <div class=\"thumb-wrapper <% if(carouselItem.onNowTitle) { %>always-on<% } %>\"  style=\"background-image: linear-gradient(240deg, #<%= carouselItem.startHexColor %>, #<%= carouselItem.endHexColor %>)\">\n                \n                    <% if (carouselItem.scheduleBadge) { %>\n                        <div class=\"schedule-badge\">\n                            <% if (carouselItem.isListingLive) { %>\n                                <span class=\"live-badge\" <% if (navigator.userAgent.indexOf('Win') != -1) { %> style=\"margin-top: 0px\" <% } %> ></span>\n                                <span class=\"badge-copy\" <% if (navigator.userAgent.indexOf('Win') != -1) { %> style=\"padding-bottom: 2px\" <% } %> ><%= getLocale('live') %></span>\n                            <% } else { %>\n                                <span class=\"badge-copy\" <% if (navigator.userAgent.indexOf('Win') != -1) { %> style=\"padding-bottom: 2px\" <% } %> ><%= carouselItem.scheduleBadgeText %></span>\n                            <% } %>\n                        </div>\n                    <% } %>\n                \n                    <!-- Promo Tile -->\n                    <% if (carouselItem.promoTile) { %>\n                        <div class=\"promoInfo\">\n                            <% if (carouselItem.ctaLine1) { %>\n                                <div class=\"promoIcon\">\n                                    <img  src=\"<%= carouselItem.promoIcon %>\" >\n                                </div>\n                            <% } %>\n                            <% if (carouselItem.ctaLine1) { %>\n                                <div class=\"promoCTALine1\"><%= carouselItem.ctaLine1 %></div>\n                            <% } %>\n                            <% if (carouselItem.ctaLine2) { %>\n                                <div class=\"promoCTALine2\"><%= carouselItem.ctaLine2 %></div>\n                            <% } %>\n                        </div>\n                    <% } %>\n                \n                    <% if (typeof editable !== 'undefined') { %>\n                        <label class=\"edit-container\">\n                            <input  type=\"checkbox\"\n                                    name=\"editor\"\n                            <% if(carouselItem.showId) { %>\n                                value=\"<%= carouselItem.showId %>/<%=carouselItem.showSeriesId%>|<%=carouselItem.showSeriesTitle%>|<%=carouselItem.showGenre%>|<%=carouselItem.showDayPart%>|<%=carouselItem.showEpisodeId%>|<%=carouselItem.showEpisodeLabel%>|<%=carouselItem.showSeasonNumber%>|<%=carouselItem.showEpisodeNumber%>|<%=carouselItem.showAirDate%>|<%=carouselItem.contentId%>\"\n                            <% } %>                >\n                            <span class=\"checkmark\"  ></span>\n                            <div class=\"overlay\" ></div>\n                        </label>\n                    <% } %>\n                \n                    <% if(!carouselItem.characterImage) { %>\n                        <img class=\"thumb lazy <% if(!carouselItem.addToMyListContentId) { %> without-addToMyList <% } %>\"\n                        <% if(carouselItem.thumb) { %>\n                            data-src=\"<%= carouselItem.thumb %>\"\n                        <% } %>\n                        <% if(carouselItem.alt) { %>\n                            alt=\"<%= carouselItem.alt %>\"\n                        <% } %>\n                        >\n                    <% } %>\n                \n                    <%// Progress Bar %>\n                    <% if(carouselItem.progress && carouselItem.progress > 0 && !carouselItem.isLive) { %>\n                        <%\n                        var progress = carouselItem.progress;\n                        %>\n                        <%# %>\n<%# You must set _uuid & progress before including this file %>\n<%# hasRendered should also be set to true during browser resize before this tpl is rendered again, see gridView.js %>\n<%# %>\n<% if (typeof _uuid !== 'undefined' && typeof progress !== 'undefined') { %>\n<style>\n\n    #progress-bar-<%= _uuid %> {\n        width: 100%;\n        height: 4px;\n        border-radius: 10px;\n        background-color: rgba(255, 255, 255, 0.5);\n    }\n\n    #progress-bar-<%= _uuid %> .bar {\n        background-color: transparent;\n        background-image: -webkit-linear-gradient(135deg, #FFFFFF, #FFFFFF);\n        background-image: linear-gradient(135deg, #FFFFFF, #FFFFFF);\n        height: 4px;\n        border-radius: 10px 0 0 10px;\n        width: 0;\n\n        -webkit-animation: slideProgress-<%= _uuid %> ease-in 1;\n        call our keyframe named fadeIn, use animattion ease-in and repeat it only 1 time\n        -moz-animation: slideProgress-<%= _uuid %> ease-in 1;\n        animation: slideProgress-<%= _uuid %> ease-in 1s;\n        -webkit-animation-fill-mode: forwards;\n\n        <%# /* this makes sure that after animation is done we remain at the last keyframe value (opacity: 1)*/ %>\n        -moz-animation-fill-mode: forwards;\n        animation-fill-mode: forwards;\n        -webkit-animation-duration: 2s;\n        -moz-animation-duration: 2s;\n        animation-duration: 2s;\n    }\n\n    #progress-bar-<%= _uuid %> .bar.hasRendered {\n        -webkit-animation-duration: 0s;\n        -moz-animation-duration: 0s;\n        animation-duration: 0s;\n    }\n\n    @-webkit-keyframes slideProgress-<%= _uuid %> {\n        from {\n            width: 0;}\n\n        to {\n            width: <%= progress %>%;\n        }\n    }\n\n    @-moz-keyframes slideProgress-<%= _uuid %> {\n        from {\n            width: 0;\n        }\n        to {\n            width: <%= progress %>%;\n        }\n    }\n\n    @keyframes slideProgress-<%= _uuid %> {\n        from {\n            width: 0;\n        }\n        to {\n            width: <%= progress %>%;\n        }\n    }\n\n</style>\n\n<div class=\"progress-bar\" id=\"progress-bar-<%= _uuid %>\" data-percentage=\"<%= progress %>\">\n    <div class=\"bar<% if (typeof hasRendered !== 'undefined' && hasRendered) { %> hasRendered <% } %>\"></div>\n</div>\n<% } %>\n                    <% } %>\n                \n                    <% if(carouselItem.characterImage) { %>\n                        <img class=\"thumb lazy character-img\" data-src=\"<%= carouselItem.characterImage %>\" src=\"<%= carouselItem.characterImage %>\" alt=\"<%= carouselItem.title %>\">\n                    <% } %>\n                \n                    <% if(carouselItem.background) { %>\n                        <img class=\"brand-bkgd-static\" src=\"<%= carouselItem.background %>\" <% if(carouselItem.fallbackBackground) { %>onerror=\"this.onerror=null; this.src='<%= carouselItem.fallbackBackground %>'\"<% } %>>\n                    <% } %>\n                \n                    <% if(carouselItem.brandLogo) { %>\n                        <div class=\"brandLogo <%= carouselItem.slug %>\">\n                            <img data-src=\"<%= carouselItem.brandLogo %>\" src=\"<%= carouselItem.brandLogo %>\" alt=\"<%= carouselItem.title %>\">\n                        </div>\n                    <% } %>\n                \n                    <% if(carouselItem.isUserSubscriber && carouselItem.bundleLocked) { %>\n                        <div class=\"<%= carouselItem.lockGradientClass %>\"></div>\n                    <% } %>\n                \n                    <% if (carouselItem.isUserSubscriber && !carouselItem.isUserRegistered && !carouselItem.addToMyListContentId && (carouselItem.locked || carouselItem.bundleLocked)) { %>\n                        <% if (!carouselItem.onNowTitle) { %>\n                            <div class=\"label <%= carouselItem.lockIconClass %>\"><img src=\"<%= carouselItem.lockIcon %>\"/></div>\n                        <% } %>\n                    <% } else if(carouselItem.icon) { %>\n                        <div class=\"label <%= carouselItem.icon %> circle-sm\"></div>\n                    <% } else if(carouselItem.status === 'PREMIUM' && !carouselItem.isUserSubscriber) { %>\n                        <div class=\"subscribe-gradient\"></div>\n                        <% if (typeof kidsContentLabel === \"undefined\" || kidsContentLabel === null) { %>\n                            <div class=\"label subscribe\"><%= getLocale('subscribe') %></div>\n                        <% } else { %>\n                            <div class=\"label subscribe\"><%= kidsContentLabel %></div>\n                        <% } %>\n                    <% } else if(carouselItem.status === 'AVAILABLE') { %>\n                        <div class=\"play label circle-sm\">\n                            <% if(carouselItem.content_id) { %>\n                                <svg class=\"svg-loader\" viewbox=\"0 0 33.83098862 33.83098862\" width=\"30\" height=\"30\"\n                                     xmlns=\"http://www.w3.org/2000/svg\">\n                                    <circle class=\"svg-loader__circle\" stroke=\"#FFFFFF\" stroke-width=\"2\" stroke-dasharray=\"100\" fill=\"none\"\n                                            cx=\"16.91549431\" cy=\"16.91549431\" r=\"15.91549431\"/>\n                                </svg>\n                            <% } %>\n                        </div>\n                    <% } %>\n                \n                    <% if(carouselItem.addToMyListContentId) { %>\n                        <div class=\"watchlist-bundle\">\n                            <% if (carouselItem.locked || carouselItem.bundleLocked){ %>\n                                <div class=\"watchlist-bundle__lock-gradient\"></div>\n                                <div class=\"watchlist-bundle__lock-icon\">\n                                    <img class=\"watchlist-bundle__lock-icon-img\" src=\"<%= carouselItem.lockIcon %>\"/>\n                                </div>\n                            <% } %>\n                        </div>\n                    <% } else { %>\n                        <% if(carouselItem.onNowTitle) { %>\n                            <div class=\"onnow-wrapper\">\n                                <div class=\"onnow-wrapper-inside\">\n                                    <div class=\"channel-logo\">\n                                        <% if (carouselItem.channelLogo) { %>\n                                            <img src=\"<%= carouselItem.channelLogo %>\">\n                                        <% } %>\n                                    </div>\n                                    <% if ( ((carouselItem.locked || carouselItem.bundleLocked) && carouselItem.isUserSubscriber) || (carouselItem.isLocal && carouselItem.lockIcon && !carouselItem.isUserSubscriber) ) { %>\n                                    <div class=\"<%= carouselItem.lockGradientClass %>\"></div>\n                                    <div class=\"label <%= carouselItem.lockIconClass %>\">\n                                        <img src=\"<%= carouselItem.lockIcon %>\"/>\n                                    </div>\n                                    <% } %>\n                                </div>\n                            </div>\n                        <% } %>\n                    <% } %>\n                \n                    <% if (carouselItem.ratingIcon && !CBS.Registry.region.international){ %>\n                        <img class=\"ratings-icon\" src=\"<%= carouselItem.ratingIcon %>\" alt=\"<%= carouselItem.ratingText %>\" />\n                    <% } %>\n                    <% if (carouselItem.badgeLabel && !carouselItem.hasNumberLabel){ %>\n                        <div class=\"new-item-container\">\n                            <div class=\"new-item\"><%= carouselItem.badgeLabel %></div>\n                        </div>\n                    <% } %>\n                \n                    \n                    <% if(carouselItem.addToMyListContentId) { %>\n                        <div class=\"watchlist_wrapper initialized\"\n                             data-content-type=\"<%= carouselItem.addToMyListContentType %>\"\n                             data-content-id=\"<%= carouselItem.addToMyListContentId %>\" >\n                            <div class=\"watchlistCta <%= carouselItem.inMyListClass %>\">\n                                <span class=\"watchlist_copy\"></span>\n                            </div>\n                            <span class=\"tooltip\">&nbsp;</span>\n                        </div>\n                    <% } %>\n                </div>\n                \n                <% //START A/B TEST PLGRWEB-1558 Live Sports Data Carousel %>\n                <% if (carouselItem.gameData) { %>\n                    <div id=\"game-<%= carouselItem.gameData.id %>\"\n                         class=\"info-wrapper sports-data-wrapper\"\n                         data-gameId=\"<%= carouselItem.gameData.id %>\"\n                         data-updateLive=\"<%= carouselItem.gameData.updateLive %>\">\n                        <div class=\"sports-inner-wrapper\">\n                            <div class=\"info-onnow-wrapper\">\n                                <div class=\"runTime noDescription\">\n                                    <span class=\"meta-gray title-label\"><%= carouselItem.gameData.leagueName %></span>\n                                    <% if (carouselItem.gameData.score) { %>\n                                        <span class=\"game-time-elapsed meta-gray\" data-gameTime=\"<%= carouselItem.gameData.score.gameTimeDisplayText %>\">\n                                            <%= carouselItem.gameData.score.gameTimeDisplayText %>\n                                        </span>\n                                    <% } %>\n                                </div>\n                            </div>\n                            <% if ((carouselItem.gameData.homeTeam) && carouselItem.gameData.awayTeam) { %>\n                                <div class=\"teams-wrapper <%= carouselItem.gameData.reverseOrder %>\">\n                                    <div class=\"team-wrapper\">\n                                        <img class=\"team-logo\" src=\"<%= carouselItem.gameData.homeTeam.teamAssets.logoSvg %>\" />\n                                        <span class=\"team-name title-label\"><%= carouselItem.gameData.homeTeam.mediumName %></span>\n                                        <% if (carouselItem.gameData.score) { %>\n                                            <span class=\"team-score home\" data-teamScore=\"<%= carouselItem.gameData.score.homeTeamScore %>\">-</span>\n                                        <% } %>\n                                    </div>\n                                    <div class=\"team-wrapper\">\n                                        <img class=\"team-logo\" src=\"<%= carouselItem.gameData.awayTeam.teamAssets.logoSvg %>\" />\n                                        <span class=\"team-name title-label\"><%= carouselItem.gameData.awayTeam.mediumName %></span>\n                                        <% if (carouselItem.gameData.score) { %>\n                                            <span class=\"team-score away\" data-teamScore=\"<%= carouselItem.gameData.score.awayTeamScore %>\">-</span>\n                                        <% } %>\n                                    </div>\n                                </div>\n                            <% } %>\n                        </div>\n                    </div>\n                <% } else { %>\n                    <% //END A/B TEST PLGRWEB-1558 Live Sports Data Carousel %>\n                \n                    <div class=\"info-wrapper\">\n                        <% if(carouselItem.onNowTitle) { %>\n                            <div class=\"info-onnow-wrapper\">\n                                <div class=\"runTime noDescription\">\n                                    <% if(carouselItem.seasonString) { %>\n                                        <span class=\"season-string\"><%= carouselItem.seasonString %></span>\n                                    <% } %>\n                                    <% if(carouselItem.isListingLive) { %>\n                                        <span class=\"meta-gray\">\n                                            <%= carouselItem.scheduleBadgeText %>\n                                        </span>\n                                    <% } %>\n                                    <span class=\"meta-gray onnow-separator\">\n                                        ·\n                                    </span>\n                                    <% if(carouselItem.isMultiChannel){ %>\n                                        <span class=\"meta-gray\">\n                                            <%= carouselItem.multiChannelName %>\n                                        </span>\n                                    <% } else if(carouselItem.isOnNow) { %>\n                                        <span class=\"meta-gray\">\n                                            <%= carouselItem.liveTvChannel %>\n                                        </span>\n                                    <% } else { %>\n                                        <% if(carouselItem.onNowTimeElapsed) { %>\n                                            <span class=\"time-details\">\n                                                <%= carouselItem.onNowTimeElapsed %>\n                                            </span>\n                                        <% } else if(carouselItem.onNowrunTime || carouselItem.onNowTimeRemaining) { %>\n                                            <span class=\"time-details\">\n                                                <%= carouselItem.onNowrunTime %> <%=carouselItem.onNowTimeRemaining %>\n                                            </span>\n                                        <% } %>\n                                    <% } %>\n                                </div>\n                                <div class=\"title-wrapper\">\n                                    <div class=\"on-title\" data-title=\"<%= carouselItem.onNowTitle %>\">\n                                        <%= carouselItem.onNowTitle %>\n                                    </div>\n                                </div>\n                            </div>\n                        <% omitTitle = true; %>\n                        <% } %>\n                    \n                        <% if(carouselItem.whatsNew && contentType) { %>\n                            <span class=\"meta-category\">\n                                <%= contentType %>\n                            </span>\n                        <% } %>\n                    \n                        <%// META DATA (Watchagain carousel show) %>\n                        <% if(carouselItem.watchAgainCarouselContentType === 'show') { %>\n                            <span class='meta-watch-again-wrapper'>\n                                <% if(!carouselItem.isSeasonless && !carouselItem.showSeasonless && carouselItem.seasonNumber) { %>\n                                    <span class=\"meta-white <%= carouselItem.metaSeasonNumberClass %>\">\n                                        <abbr aria-label=\"Season <%= carouselItem.seasonNumber %>\" title=\"<%= getLocale('season') %> <%= carouselItem.seasonNumber %>\">\n                                            <%= getLocale('season_number_abbr', {'seasonNumber': carouselItem.seasonNumber }) %>\n                                        </abbr>\n                                    </span>\n                                <% } %>\n                                <% if(!carouselItem.isEpisodeless && !carouselItem.showEpisodeless && carouselItem.episodeNumber) { %>\n                                    <span class=\"meta-white <%= carouselItem.metaEpisodeNumberClass %>\">\n                                        <abbr aria-label=\"Episode <%= carouselItem.episodeNumber %>\" title=\"<%= getLocale('episode') %> <%= carouselItem.episodeNumber %>\">\n                                            <%= getLocale('episode_number_abbr', {'episodeNum': carouselItem.episodeNumber }) %>\n                                        </abbr>\n                                    </span>\n                                <% } %>\n                                <% if(carouselItem.episodeOrClipTitle) { %>\n                                    <span class=\"meta-gray meta-episode-title\">\n                                        <%= carouselItem.episodeOrClipTitle %>\n                                    </span>\n                                <% } %>\n                            </span>\n                        <% } %>\n                        \n                        <div class=\"meta-gray-wrapper title-shorten\">\n                            \n                        <%// META DATA (Watchagain carousel movie) %>\n                        <% if(carouselItem.watchAgainCarouselContentType === 'movie') { %>\n                            <span class=\"meta-gray meta-airdate <%= carouselItem.startDateISOClass %>\">\n                                <time datetime=\"<%= carouselItem.startDateISO %>\">\n                                    <%= carouselItem.startDate %>\n                                </time>\n                            </span>\n                        <% } %>\n                    \n                        <%// META DATA (show) %>\n                        <% if(!carouselItem.isMovie && !carouselItem.watchAgainCarouselContentType) { %>\n                            <% if(carouselItem.content_type !== \"Clip\") { %>\n                                <% if(!carouselItem.isSeasonless && !carouselItem.showSeasonless && carouselItem.seasonNumber) { %>\n                                    <span class=\"meta-white  <% if(CBS.Registry.Features.web_episode_descriptions_enabled) { %>season-inline<% } %>\">\n                                        <abbr class=\"<% if(CBS.Registry.Features.web_episode_descriptions_enabled) { %>season-inline<% } %>\" aria-label=\"Season <%= carouselItem.seasonNumber %>\" title=\"<%= getLocale('season') %> <%= carouselItem.seasonNumber %>\">\n                                            <%= getLocale('season_number_abbr', {'seasonNumber': carouselItem.seasonNumber }) %>\n                                        </abbr>\n                                    </span>\n                                <% } %>\n                                <% if(!carouselItem.isEpisodeless && !carouselItem.showEpisodeless && carouselItem.episodeNumber) { %>\n                                    <span class=\"meta-white <% if(CBS.Registry.Features.web_episode_descriptions_enabled) { %>season-inline<% } %>\">\n                                        <abbr class=\"<% if(CBS.Registry.Features.web_episode_descriptions_enabled) { %>season-inline<% } %>\" aria-label=\"Episode <%= carouselItem.episodeNumber %>\" title=\"<%= getLocale('episode') %> <%= carouselItem.episodeNumber %>\">\n                                            <%= getLocale('episode_number_abbr', {'episodeNum': carouselItem.episodeNumber }) %>\n                                        </abbr>\n                                    </span>\n                                <% } %>\n\n\n                                <% if(CBS.Registry.pageType !== 'movies' && CBS.Registry.pageType !== 'HOMEPAGE' && carouselItem.brand !== 'CBS News' && CBS.Registry.Features.web_episode_descriptions_enabled && carouselItem.title && omitTitle === false && carouselItem.whatsNew !== true) { %>\n                                    <%= carouselItem.title %>\n                                    <% omitTitle = true; %>\n                                    <% showDuration = true; %>\n                                <% } %>\n                            \n                            \n                            \n                            \n                                <% if(CBS.Registry.pageType !== 'movies' ) { %>\n                                    <% if(!carouselItem.isNewsTopStories && carouselItem.airDate !== 0 && (!CBS.Registry.Features.web_episode_descriptions_enabled || carouselItem.carouselType === 'keep-watching')) { %>\n                                        <span class=\"meta-gray meta-airdate <%= carouselItem.startDateISOClass %>\">\n                                            <time datetime=\"<%= carouselItem.startDateISO %>\">\n                                                <%= carouselItem.startDate %>\n                                            </time>\n                                        </span>\n                                    <% } else if(carouselItem.mediaType !== \"Clip\" && (CBS.Registry.Features.web_episode_descriptions_enabled && omitTitle === false && carouselItem.whatsNew !== true && carouselItem.isNewsTopStories === false)) { %>\n                                        <% omitTitle = true; %>\n                                        <span class=\"title-wrapper\">\n                                            <span class=\"title title-inline\" data-title=\"<%= carouselItem.title %>\">\n                                                <% if(displayShowTitle && carouselItem.seriesTitle) { %>\n                                                <%= carouselItem.seriesTitle %> |\n                                                <% } %>\n                                                <%= carouselItem.title %>\n                                            </span>\n                                        </span>\n                                    <% } %>\n                                <% } %>\n                            <% } %>\n                        <% } %>\n                    \n                        <%// META DATA (newsTopStories) %>\n                        <% if(carouselItem.isNewsTopStories && carouselItem.startDate) { %>\n                            <span class=\"meta-gray meta-airdate\">\n                                <time datetime=\"<%= carouselItem.startDateISO %>\">\n                                    <%= carouselItem.startDate %>\n                                </time>\n                            </span>\n                        <% } %>\n                    \n                        <%// FOR NOMINEE USE ONLY %>\n                        <% if(carouselItem.winner) { %>\n                            <span class=\"nom-winner\">\n                                <img class=\"thumb lazy\" data-src=\"<%= carouselItem.winner_icon %>\" alt=\"Winner\" title=\"Winner\" />\n                            </span>\n                        <% } %>\n                        \n                        <%// DURATION %>\n                        <% if(!CBS.Registry.Features.web_episode_descriptions_enabled) { %>\n                            <% if(!carouselItem.isMovie && carouselItem.duration && !carouselItem.onNowTitle && carouselItem.displayItemTitle && carouselItem.mediaType !== \"Full Episode\"){ %>\n                                <span class=\"meta-gray\">\n                                    <%= carouselItem.duration %>\n                                </span>\n                            <% } %>\n                        <% } %>\n                    \n                        <%// CHARACTER NAME %>\n                        <% if(carouselItem.characterName){ %>\n                            <span class=\"meta-gray\">\n                                <%= carouselItem.characterName %>\n                            </span>\n                        <% } %>\n                    \n                        <%// LIVE TV SCHEDULE START TIME %>\n                        <% if(carouselItem.startTime){ %>\n                            <div class=\"startTime-wrapper\">\n                                <div class=\"startTime\">\n                                    <%= carouselItem.startTime %>\n                                </div>\n                                <% if(i == 0){ %>\n                                    <div class=\"liveNow\"><div class=\"blue-dot blinking\"></div> LIVE</div>\n                                <% } %>\n                            </div>\n                        <% } %>\n                    \n                    \n                        <%// MOVIE YEAR DURATION RATING  %>\n                        <% if((carouselItem.rating || carouselItem.yearMin) && contentType==='movie' && carouselItem.orientation != 'portrait'){ %>\n                            <span class=\"meta-gray\">\n                            <% if(carouselItem.yearMin){ %>\n                                <%= carouselItem.yearMin %>\n                            <% } %>\n                            <% if(carouselItem.rating && !CBS.Registry.region.international && (!CBS.Registry.Features.web_episode_descriptions_enabled || carouselItem.carouselType === 'keep-watching')){ %>\n                                <%= carouselItem.rating %>\n                            <% } %>\n                            </span>\n                        <% } %>\n\n                        </div>\n                    \n                        <%// TITLE %>\n                        <% if(carouselItem.title && !carouselItem.onNowTitle && carouselItem.displayItemTitle && omitTitle === false){ %>\n                            <div class=\"title-wrapper\">\n                                <div class=\"title\" data-title=\"<%= carouselItem.title %>\">\n                                    <% if(displayShowTitle && carouselItem.seriesTitle) { %>\n                                        <%= carouselItem.seriesTitle %> |\n                                    <% } %>\n                                    <%= carouselItem.title %>\n                                </div>\n                            </div>\n                        <% omitTitle = true; %>\n                        <% } %>\n                    \n                        <%// LIVE TV SCHEDULE DESCRIPTION %>\n                        <% if(carouselItem.description && CBS.Registry.Features.web_episode_descriptions_enabled){ %>\n                            <div class=\"description-wrapper\" id=\"js-schedule-description\">\n                                <div class=\"description limited-text\" id=\"js-schedule-copy\">\n                                    <%= carouselItem.description %>\n                                </div>\n                                <div class=\"runTime\">\n                                    <%= carouselItem.runTime %>\n                                </div>\n                            </div>\n                        <% } else if(carouselItem.runTime) { %>\n                            <div class=\"runTime noDescription\">\n                                <%= carouselItem.runTime %>\n                            </div>\n                        <% } %>\n\n                        <% if(CBS.Registry.Features.web_episode_descriptions_enabled && (CBS.Registry.pageType === 'movies' || omitTitle === false || (showDuration === true && carouselItem.mediaType === \"Full Episode\"))) { %>\n                            <%# DURATION %>\n                            <span class=\"meta-gray lower-case\">\n                                <%= carouselItem.duration %>\n                            </span>\n    \n                            <%# AIRDATE %>\n                            <span class=\"meta-gray <%= carouselItem.mediaType === \"Clip\" ? 'meta-airdate-left' : 'meta-airdate' %>\">\n                                <time datetime=\"<%= carouselItem.startDate %>\">\n                                    <%= carouselItem.startDate %>\n                                </time>\n                            </span>\n                        <% } %>\n                        \n                        <%// GUESTS APPEARANCE DATE %>\n                        <% if(carouselItem.appearanceDate){ %>\n                            <div class=\"guests-appearance-date\">\n                                <%= carouselItem.appearanceDate %>\n                            </div>\n                        <% } %>\n                    \n                        <%// GUESTS %>\n                        <% if(carouselItem.guests_array){ %>\n                            <div class=\"guests\" id=\"guests\"></div>\n                            <%\n                            var div = document.getElementById('guests');\n                            for(var guest in carouselItem.guests_array) {\n                                div.innerHTML += '<div class=\"guest\">'+guest+'</div>';\n                            }\n                            %>\n                        <% } %>\n                    \n                    </div>\n\n                <% } %>\n\n            <% } %>\n\n        </a>\n\n        <div class=\"break\"></div>\n\n    <% } %>\n\n<%  } %>"
  , __filename = "node_modules/.pnpm/git@github.com+cbsi-cbscom+web-package-coreui@7d7ba8afd4bc5ca2bfaf5656bcb870d17e89ab51_fetch-_k4du5uksy5fad7om3lugymerom/node_modules/cbs-core-ui/src/js/templates/carousels/__carousel.tpl";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  var __locals = (locals || {}),
data = __locals.data,
  selected = __locals.selected;
  with (locals || {}) {
    ; 
for (var i = 0; i < data.length; i++) {

    var carouselItem = data[i];

    var _uuid = Math.floor((Math.random() * 1000000) + 1);
    var title = '';
    if(carouselItem.title){
        title = carouselItem.title;
    }else if(carouselItem.alt){
        title = carouselItem.alt;
    }

    var phatomTitle = title;

    if(carouselItem.dataTracking){
        var splittedTracking = carouselItem.dataTracking.split('|');
        phatomTitle = splittedTracking[0];
    }

    var id;
    if(carouselItem.id || carouselItem.id === 0){
        id = carouselItem.id
    }else{
        id = carouselItem.contentId
    }

    var contentType = 'show';

    if(carouselItem.contentType){
        contentType = carouselItem.contentType;
    }

    if(carouselItem.isMovie){
        contentType = 'movie';
    }
 
    var impressionContentType = contentType;
    if(carouselItem.isOnNow){
        impressionContentType = carouselItem.streamType;
    }

    if (carouselItem.showSeasonless && carouselItem.showEpisodeless && carouselItem.isCollectionCarousel) {
        carouselItem.startDateISOClass = 'meta-airdate-left';
        carouselItem.metaSeasonNumberClass = 'hide';
        carouselItem.metaEpisodeNumberClass = 'hide';
    } else {
        carouselItem.startDateISOClass = '';
        carouselItem.metaSeasonNumberClass = '';
        carouselItem.metaEpisodeNumberClass = '';
    }

    if ((carouselItem.locked || carouselItem.bundleLocked) && carouselItem.isUserSubscriber && !carouselItem.addToMyListContentId) {
        if(carouselItem.orientation == 'portrait'){
            carouselItem.lockIconClass = 'bundle-lock portrait';
        }else{
            carouselItem.lockIconClass = 'bundle-lock';
        }
        
        carouselItem.lockGradientClass = 'bundle-lock-gradient';
    }

    var cmsId = '';
    if(carouselItem.cmsId) {
        cmsId = carouselItem.cmsId;
    }

    var linkClasses = '';
    if(carouselItem.status === 'PREMIUM' && !carouselItem.isUserSubscriber) {
        linkClasses += ' subscribe';
    }

    if (typeof zoomCarouselEffectClass === 'string' && zoomCarouselEffectClass && !carouselItem.promoTile) {
        linkClasses += ' ';
        linkClasses += zoomCarouselEffectClass;
    }
    
    if(carouselItem?.hasContentHighlight == true) {
        linkClasses += ' content-highlight-enabled';
    }

    var linkClass = '';

    if (carouselItem.hasNumberLabel) {
        linkClass += 'numeric-link';
    }

    var ctaText = carouselItem.button?.label ?? "";

    ; __line = 89
    ; __append("\n\n    ")
    ; __line = 91
    ;  if(carouselItem) { 
    ; __append("\n\n        <a class=\"link ")
    ; __line = 93
    ; __append(escapeFn( linkClass ))
    ; __append(" ")
    ; __append(escapeFn( (carouselItem.status === 'PREMIUM' && !carouselItem.isUserSubscriber)?'subscribe':'' ))
    ; __append(" ")
    ; __append(escapeFn( linkClasses ))
    ; __append("\"\n        aria-label=\"")
    ; __line = 94
    ;  if(title) { 
    ; __append(escapeFn( title ))
    ;  } 
    ; __append("\"\n        ")
    ; __line = 95
    ;  if(carouselItem.titleSlug) { 
    ; __append("\n        aria-describedby=\"")
    ; __line = 96
    ; __append(escapeFn( carouselItem.titleSlug ))
    ; __append("-content\"\n        ")
    ; __line = 97
    ;  } 
    ; __append("\n        ")
    ; __line = 98
    ;  if(ctaText) { 
    ; __append("\n        data-cta=\"")
    ; __line = 99
    ; __append(escapeFn( ctaText ))
    ; __append("\"\n        ")
    ; __line = 100
    ;  } 
    ; __append("\n        ")
    ; __line = 101
    ;  if(id !== null ) { 
    ; __append("\n        id=\"")
    ; __line = 102
    ; __append(escapeFn( id ))
    ; __append("\"\n        ")
    ; __line = 103
    ;  } 
    ; __append("\n        ")
    ; __line = 104
    ;  if(carouselItem.genre) { 
    ; __append("\n        data-genre=\"")
    ; __line = 105
    ; __append(escapeFn( carouselItem.genre ))
    ; __append("\"\n        ")
    ; __line = 106
    ;  } 
    ; __append("\n        ")
    ; __line = 107
    ;  if(carouselItem.showGenre) { 
    ; __append("\n        data-genre=\"")
    ; __line = 108
    ; __append(escapeFn( carouselItem.showGenre ))
    ; __append("\"\n        ")
    ; __line = 109
    ;  } 
    ; __append("\n        ")
    ; __line = 110
    ;  if(carouselItem.href !== '') { 
    ; __append("\n        href=\"")
    ; __line = 111
    ; __append(escapeFn( carouselItem.href ))
    ; __append("\"\n        ")
    ; __line = 112
    ;  } 
    ; __append("\n        ")
    ; __line = 113
    ;  if(carouselItem.actionTarget !== '') { 
    ; __append("\n        target=\"")
    ; __line = 114
    ; __append(escapeFn( carouselItem.actionTarget ))
    ; __append("\"\n        ")
    ; __line = 115
    ;  } 
    ; __append("\n        ")
    ; __line = 116
    ;  if(title !== '') { 
    ; __append("\n        title=\"")
    ; __line = 117
    ; __append(escapeFn( title ))
    ; __append("\"\n        ")
    ; __line = 118
    ;  } 
    ; __append("\n        ")
    ; __line = 119
    ;  if(carouselItem.aaLink !== '') { 
    ; __append("\n        aa-link=\"")
    ; __line = 120
    ; __append(escapeFn( carouselItem.aaLink ))
    ; __append("\"\n        ")
    ; __line = 121
    ;  } 
    ; __append("\n        ")
    ; __line = 122
    ;  if(carouselItem.dataTracking) { 
    ; __append("\n        data-tracking=\"")
    ; __line = 123
    ; __append(escapeFn( carouselItem.dataTracking ))
    ; __append("\"\n        ")
    ; __line = 124
    ;  } 
    ; __append("\n        ")
    ; __line = 125
    ;  if(carouselItem.content_id) { 
    ; __append("\n        vilynx-id=\"")
    ; __line = 126
    ; __append(escapeFn(carouselItem.content_id))
    ; __append("\"\n        ")
    ; __line = 127
    ;  } 
    ; __append("\n        ")
    ; __line = 128
    ;  if (typeof carouselItem.contentId !== 'undefined') { 
    ; __append("\n        vilynx-id=\"")
    ; __line = 129
    ; __append(escapeFn(carouselItem.contentId))
    ; __append("\"\n        ")
    ; __line = 130
    ;  } 
    ; __append("\n        ")
    ; __line = 131
    ;  if (carouselItem.promoTile) { 
    ; __append("\n        data-fathom = '")
    ; __line = 132
    ; __append(escapeFn(carouselItem.hubId))
    ; __append("||")
    ; __append(escapeFn(i))
    ; __append("|promo_")
    ; __append(escapeFn(carouselItem.contentType))
    ; __append("||")
    ; __append(escapeFn(carouselItem.title))
    ; __append("||'\n        data-impression = '")
    ; __line = 133
    ; __append(escapeFn(carouselItem.hubId))
    ; __append("||")
    ; __append(escapeFn(i))
    ; __append("|promo_")
    ; __append(escapeFn(carouselItem.contentType))
    ; __append("||")
    ; __append(escapeFn(carouselItem.title))
    ; __append("|||||'\n        ")
    ; __line = 134
    ;  } else { 
    ; __append("\n        data-fathom = '")
    ; __line = 135
    ; __append(escapeFn(carouselItem.contentIdFathom))
    ; __append("|getdisplayIDAbove|")
    ; __append(escapeFn(i))
    ; __append("|")
    ; __append(escapeFn(contentType))
    ; __append("|")
    ; __append(escapeFn(carouselItem.recoId))
    ; __append("|")
    ; __append(escapeFn(phatomTitle))
    ; __append("|")
    ; __append(escapeFn(carouselItem.rankModel))
    ; __append("|")
    ; __append(escapeFn(carouselItem.pvrModel))
    ; __append("'\n        data-impression = '")
    ; __line = 136
    ; __append(escapeFn(carouselItem.contentIdFathom))
    ; __append("|getdisplayIDAbove|")
    ; __append(escapeFn(i))
    ; __append("|")
    ; __append(escapeFn(impressionContentType))
    ; __append("|")
    ; __append(escapeFn(carouselItem.recoId))
    ; __append("|")
    ; __append(escapeFn(phatomTitle))
    ; __append("|")
    ; __append(escapeFn(carouselItem.rankModel))
    ; __append("|")
    ; __append(escapeFn(carouselItem.pvrModel))
    ; __append("|")
    ; __append(escapeFn(carouselItem.badgeLabel))
    ; __append("|")
    ; __append(escapeFn(carouselItem.bundleLocked))
    ; __append("|")
    ; __append(escapeFn(cmsId))
    ; __append("'\n        ")
    ; __line = 137
    ;  } 
    ; __append("\n        >\n\n        ")
    ; __line = 140
    ;  omitTitle = false; 
    ; __append("\n        ")
    ; __line = 141
    ;  showDuration = false; 
    ; __append("\n\n            ")
    ; __line = 143
    ; // VIDEOCONFIG CAROUSEL 

    ; __append("\n            ")
    ; __line = 144
    ;  if(typeof model !== 'undefined' && model === 'videoConfig') { 
    ; __append("\n\n                <div class=\"thumb-wrapper ")
    ; __line = 146
    ;  if(carouselItem.onNowTitle) { 
    ; __append("always-on")
    ;  } 
    ; __append("\"  style=\"background-image: linear-gradient(240deg, #")
    ; __append(escapeFn( carouselItem.startHexColor ))
    ; __append(", #")
    ; __append(escapeFn( carouselItem.endHexColor ))
    ; __append(")\">\n                \n                    ")
    ; __line = 148
    ;  if(!carouselItem.characterImage) { 
    ; __append("\n                        <img class=\"thumb lazy\"\n                        ")
    ; __line = 150
    ;  if(carouselItem.thumb) { 
    ; __append("\n                            data-src=\"")
    ; __line = 151
    ; __append(escapeFn( carouselItem.thumb ))
    ; __append("\"\n                        ")
    ; __line = 152
    ;  } 
    ; __append("\n                        ")
    ; __line = 153
    ;  if(carouselItem.alt) { 
    ; __append("\n                            alt=\"")
    ; __line = 154
    ; __append(escapeFn( carouselItem.alt ))
    ; __append("\"\n                        ")
    ; __line = 155
    ;  } 
    ; __append("\n                        >\n                    ")
    ; __line = 157
    ;  } 
    ; __append("\n                \n                    ")
    ; __line = 159
    ; // Progress Bar 

    ; __append("\n                    ")
    ; __line = 160
    ;  if(carouselItem.progress && carouselItem.progress > 0) { 
    ; __append("\n                        ")
    ; __line = 161
    ; 
                        var progress = carouselItem.progress;
                        
    ; __line = 163
    ; __append("\n                        ")
    ; __line = 164
    ; __append("\n")
    ; __line = 165
    ; __append("\n")
    ; __line = 166
    ; __append("\n")
    ; __line = 167
    ; __append("\n")
    ; __line = 168
    ;  if (typeof _uuid !== 'undefined' && typeof progress !== 'undefined') { 
    ; __append("\n<style>\n\n    #progress-bar-")
    ; __line = 171
    ; __append(escapeFn( _uuid ))
    ; __append(" {\n        width: 100%;\n        height: 4px;\n        border-radius: 10px;\n        background-color: rgba(255, 255, 255, 0.5);\n    }\n\n    #progress-bar-")
    ; __line = 178
    ; __append(escapeFn( _uuid ))
    ; __append(" .bar {\n        background-color: transparent;\n        background-image: -webkit-linear-gradient(135deg, #FFFFFF, #FFFFFF);\n        background-image: linear-gradient(135deg, #FFFFFF, #FFFFFF);\n        height: 4px;\n        border-radius: 10px 0 0 10px;\n        width: 0;\n\n        -webkit-animation: slideProgress-")
    ; __line = 186
    ; __append(escapeFn( _uuid ))
    ; __append(" ease-in 1;\n        call our keyframe named fadeIn, use animattion ease-in and repeat it only 1 time\n        -moz-animation: slideProgress-")
    ; __line = 188
    ; __append(escapeFn( _uuid ))
    ; __append(" ease-in 1;\n        animation: slideProgress-")
    ; __line = 189
    ; __append(escapeFn( _uuid ))
    ; __append(" ease-in 1s;\n        -webkit-animation-fill-mode: forwards;\n\n        ")
    ; __line = 192
    ; __append("\n        -moz-animation-fill-mode: forwards;\n        animation-fill-mode: forwards;\n        -webkit-animation-duration: 2s;\n        -moz-animation-duration: 2s;\n        animation-duration: 2s;\n    }\n\n    #progress-bar-")
    ; __line = 200
    ; __append(escapeFn( _uuid ))
    ; __append(" .bar.hasRendered {\n        -webkit-animation-duration: 0s;\n        -moz-animation-duration: 0s;\n        animation-duration: 0s;\n    }\n\n    @-webkit-keyframes slideProgress-")
    ; __line = 206
    ; __append(escapeFn( _uuid ))
    ; __append(" {\n        from {\n            width: 0;}\n\n        to {\n            width: ")
    ; __line = 211
    ; __append(escapeFn( progress ))
    ; __append("%;\n        }\n    }\n\n    @-moz-keyframes slideProgress-")
    ; __line = 215
    ; __append(escapeFn( _uuid ))
    ; __append(" {\n        from {\n            width: 0;\n        }\n        to {\n            width: ")
    ; __line = 220
    ; __append(escapeFn( progress ))
    ; __append("%;\n        }\n    }\n\n    @keyframes slideProgress-")
    ; __line = 224
    ; __append(escapeFn( _uuid ))
    ; __append(" {\n        from {\n            width: 0;\n        }\n        to {\n            width: ")
    ; __line = 229
    ; __append(escapeFn( progress ))
    ; __append("%;\n        }\n    }\n\n</style>\n\n<div class=\"progress-bar\" id=\"progress-bar-")
    ; __line = 235
    ; __append(escapeFn( _uuid ))
    ; __append("\" data-percentage=\"")
    ; __append(escapeFn( progress ))
    ; __append("\">\n    <div class=\"bar")
    ; __line = 236
    ;  if (typeof hasRendered !== 'undefined' && hasRendered) { 
    ; __append(" hasRendered ")
    ;  } 
    ; __append("\"></div>\n</div>\n")
    ; __line = 238
    ;  } 
    ; __append("\n                    ")
    ; __line = 239
    ;  } 
    ; __append("\n                \n                    ")
    ; __line = 241
    ;  if(carouselItem.characterImage) { 
    ; __append("\n                        <img class=\"thumb lazy character-img\" data-src=\"")
    ; __line = 242
    ; __append(escapeFn( carouselItem.characterImage ))
    ; __append("\" src=\"")
    ; __append(escapeFn( carouselItem.characterImage ))
    ; __append("\" alt=\"")
    ; __append(escapeFn( carouselItem.title ))
    ; __append("\">\n                    ")
    ; __line = 243
    ;  } 
    ; __append("\n                \n                    ")
    ; __line = 245
    ;  if(carouselItem.background) { 
    ; __append("\n                        <img class=\"brand-bkgd-static\" src=\"")
    ; __line = 246
    ; __append(escapeFn( carouselItem.background ))
    ; __append("\" ")
    ;  if(carouselItem.fallbackBackground) { 
    ; __append("onerror=\"this.onerror=null; this.src='")
    ; __append(escapeFn( carouselItem.fallbackBackground ))
    ; __append("'\"")
    ;  } 
    ; __append(">\n                    ")
    ; __line = 247
    ;  } 
    ; __append("\n                \n                    ")
    ; __line = 249
    ;  if(carouselItem.isUserSubscriber && carouselItem.bundleLocked) { 
    ; __append("\n                        <div class=\"")
    ; __line = 250
    ; __append(escapeFn( carouselItem.lockGradientClass ))
    ; __append("\"></div>\n                    ")
    ; __line = 251
    ;  } 
    ; __append("\n                \n                    ")
    ; __line = 253
    ;  if (carouselItem.isUserSubscriber && !carouselItem.isUserRegistered && !carouselItem.addToMyListContentId && (carouselItem.locked || carouselItem.bundleLocked)) { 
    ; __append("\n                        ")
    ; __line = 254
    ;  if (!carouselItem.onNowTitle) { 
    ; __append("\n                            <div class=\"label ")
    ; __line = 255
    ; __append(escapeFn( carouselItem.lockIconClass ))
    ; __append("\"><img src=\"")
    ; __append(escapeFn( carouselItem.lockIcon ))
    ; __append("\"/></div>\n                        ")
    ; __line = 256
    ;  } 
    ; __append("\n                    ")
    ; __line = 257
    ;  } else if(carouselItem.icon) { 
    ; __append("\n                        <div class=\"label ")
    ; __line = 258
    ; __append(escapeFn( carouselItem.icon ))
    ; __append(" circle-sm\"></div>\n                    ")
    ; __line = 259
    ;  } else if(carouselItem.status === 'PREMIUM' && !carouselItem.isUserSubscriber) { 
    ; __append("\n                        <div class=\"subscribe-gradient\"></div>\n                        ")
    ; __line = 261
    ;  if (typeof kidsContentLabel === "undefined" || kidsContentLabel === null) { 
    ; __append("\n                            <div class=\"label subscribe\">")
    ; __line = 262
    ; __append(escapeFn( getLocale('subscribe') ))
    ; __append("</div>\n                        ")
    ; __line = 263
    ;  } else { 
    ; __append("\n                            <div class=\"label subscribe\">")
    ; __line = 264
    ; __append(escapeFn( kidsContentLabel ))
    ; __append("</div>\n                        ")
    ; __line = 265
    ;  } 
    ; __append("\n                    ")
    ; __line = 266
    ;  } else if(carouselItem.status === 'AVAILABLE') { 
    ; __append("\n                        <div class=\"play label circle-sm\">\n                            ")
    ; __line = 268
    ;  if(carouselItem.content_id) { 
    ; __append("\n                                <svg class=\"svg-loader\" viewbox=\"0 0 33.83098862 33.83098862\" width=\"30\" height=\"30\"\n                                     xmlns=\"http://www.w3.org/2000/svg\">\n                                    <circle class=\"svg-loader__circle\" stroke=\"#FFFFFF\" stroke-width=\"2\" stroke-dasharray=\"100\" fill=\"none\"\n                                            cx=\"16.91549431\" cy=\"16.91549431\" r=\"15.91549431\"/>\n                                </svg>\n                            ")
    ; __line = 274
    ;  } 
    ; __append("\n                        </div>\n                    ")
    ; __line = 276
    ;  } 
    ; __append("\n                </div>\n                \n                <div class=\"info-wrapper\">\n                ")
    ; __line = 280
    ; // META DATA 

    ; __append("\n                ")
    ; __line = 281
    ;  if(!carouselItem.isMovie && carouselItem.mediaType !== "Movie" && carouselItem.mediaType !== "Standalone" && carouselItem.mediaType !== "Live" && carouselItem.mediaType !== "Clip" && carouselItem.mediaType !== "Trailer") { 
    ; __append("\n\n                    <div class=\"meta-gray-wrapper\">\n                    ")
    ; __line = 284
    ;  //Shows 

    ; __append("\n                    ")
    ; __line = 285
    ;  if(!carouselItem.isSeasonless && !carouselItem.showSeasonless && carouselItem.seasonNumber) { 
    ; __append("\n                        <span class=\"meta-white\">\n                            <abbr aria-label=\"Season ")
    ; __line = 287
    ; __append(escapeFn( carouselItem.seasonNumber ))
    ; __append("\" title=\"")
    ; __append(escapeFn( getLocale('season') ))
    ; __append(" ")
    ; __append(escapeFn( carouselItem.seasonNumber ))
    ; __append("\">\n                                ")
    ; __line = 288
    ; __append(escapeFn( getLocale('season_number_abbr', {'seasonNumber': carouselItem.seasonNumber }) ))
    ; __append("\n                            </abbr>\n                        </span>\n                    ")
    ; __line = 291
    ;  } 
    ; __append("\n                    ")
    ; __line = 292
    ;  if(!carouselItem.isEpisodeless && !carouselItem.showEpisodeless && carouselItem.episodeNumber) { 
    ; __append("\n                        <span class=\"meta-white\">\n                            <abbr aria-label=\"Episode ")
    ; __line = 294
    ; __append(escapeFn( carouselItem.episodeNumber ))
    ; __append("\" title=\"")
    ; __append(escapeFn( getLocale('episode') ))
    ; __append(" ")
    ; __append(escapeFn( carouselItem.episodeNumber ))
    ; __append("\">\n                                ")
    ; __line = 295
    ; __append(escapeFn( getLocale('episode_number_abbr', {'episodeNum': carouselItem.episodeNumber }) ))
    ; __append("\n                            </abbr>\n                        </span>\n                    ")
    ; __line = 298
    ;  } 
    ; __append("\n                    \n                    ")
    ; __line = 300
    ;  if(displayShowTitle) { 
    ; __append("\n                        <span class=\"meta-gray\">\n                            ")
    ; __line = 302
    ; __append(escapeFn( carouselItem.title ))
    ; __append("\n                        </span>\n                    ")
    ; __line = 304
    ;  } else if(carouselItem.airDate !== 0 && carouselItem.chAirDate) { 
    ; __append("\n                        <span class=\"meta-gray meta-airdate\">\n                            <time datetime=\"")
    ; __line = 306
    ; __append(escapeFn( carouselItem.startDateISO ))
    ; __append("\">\n                                ")
    ; __line = 307
    ; __append(escapeFn( carouselItem.chAirDate ))
    ; __append("\n                            </time>\n                        </span>\n                    ")
    ; __line = 310
    ;  } 
    ; __append("\n                    </div>\n                \n                    <div class=\"title-wrapper\">\n                        <div class=\"title\" data-title=\"")
    ; __line = 314
    ; __append(escapeFn( carouselItem.title ))
    ; __append("\">\n                            ")
    ; __line = 315
    ;  if(displayShowTitle && carouselItem.seriesTitle) { 
    ; __append("\n                                ")
    ; __line = 316
    ; __append(escapeFn( carouselItem.seriesTitle ))
    ; __append("\n                            ")
    ; __line = 317
    ;  } else { 
    ; __append("\n                                ")
    ; __line = 318
    ; __append(escapeFn( carouselItem.title ))
    ; __append("\n                            ")
    ; __line = 319
    ;  } 
    ; __append("\n                        </div>\n                    </div>\n                \n                    ")
    ; __line = 323
    ;  } else { 
    ; __append("\n                        ")
    ; __line = 324
    ;  //Movie, CLIP, TRAILER, or LIVE Part 

    ; __append("\n                        ")
    ; __line = 325
    ;  if(carouselItem.mediaType === "Movie" || carouselItem.mediaType === "Standalone") { 
    ; __append("\n                            <div class=\"title-wrapper\">\n                                <div class=\"title\" data-title=\"")
    ; __line = 327
    ; __append(escapeFn( carouselItem.title ))
    ; __append("\">\n                                    ")
    ; __line = 328
    ; __append(escapeFn( carouselItem.title ))
    ; __append("\n                                </div>\n                            </div>\n                        ")
    ; __line = 331
    ;  } else if(carouselItem.mediaType === "Clip" || carouselItem.mediaType === "Trailer") { 
    ; __append("\n                            <div class=\"meta-gray-wrapper\">\n                            ")
    ; __line = 333
    ;  if(carouselItem.duration) { 
    ; __append("\n                                <span class=\"meta-gray\">\n                                    ")
    ; __line = 335
    ; __append(escapeFn( carouselItem.duration ))
    ; __append("\n                                </span>\n                            ")
    ; __line = 337
    ;  } 
    ; __append("\n                            ")
    ; __line = 338
    ;  if(displayShowTitle) { 
    ; __append("\n                                <span class=\"meta-gray\">\n                                    ")
    ; __line = 340
    ; __append(escapeFn( carouselItem.showOrMovieTitle  ))
    ; __append("\n                                </span>\n                            ")
    ; __line = 342
    ;  } 
    ; __append("\n                            </div>\n                        <div class=\"title-wrapper\">\n                            <div class=\"title\" data-title=\"")
    ; __line = 345
    ; __append(escapeFn( carouselItem.label ))
    ; __append("\">\n                                ")
    ; __line = 346
    ; __append(escapeFn( carouselItem.label ))
    ; __append("\n                            </div>\n                        </div>\n                    ")
    ; __line = 349
    ;  } 
    ; __append("\n                ")
    ; __line = 350
    ;  //No Meta Data for Live 

    ; __append("\n                ")
    ; __line = 351
    ;  } 
    ; __append("\n                </div>\n\n            ")
    ; __line = 354
    ; // DEFAULT CAROUSEL 

    ; __append("\n            ")
    ; __line = 355
    ;  } else { 
    ; __append("\n\n                ")
    ; __line = 357
    ;  if(carouselItem.titleSlug) { 
    ; __append("\n                    <span class=\"aria-item-content\" id=\"")
    ; __line = 358
    ; __append(escapeFn( carouselItem.titleSlug ))
    ; __append("-content\">\n                        ")
    ; __line = 359
    ; __append(escapeFn( carouselItem.about ))
    ; __append("\n                    </span>\n                ")
    ; __line = 361
    ;  } 
    ; __append("\n\n                ")
    ; __line = 363
    ;  if (carouselItem.hasNumberLabel) { 
    ; __append("\n                <div class=\"numeric-container ")
    ; __line = 364
    ;  if (carouselItem.numberLabel > 9) { 
    ; __append("double-digit")
    ;  } 
    ; __append("\">\n                    <div class=\"text-stroke\" data-text=\"")
    ; __line = 365
    ; __append(escapeFn( carouselItem.numberLabel ))
    ; __append("\">")
    ; __append(escapeFn( carouselItem.numberLabel ))
    ; __append("</div>\n                </div>\n                ")
    ; __line = 367
    ;  } 
    ; __append("\n\n                <div class=\"thumb-wrapper ")
    ; __line = 369
    ;  if(carouselItem.onNowTitle) { 
    ; __append("always-on")
    ;  } 
    ; __append("\"  style=\"background-image: linear-gradient(240deg, #")
    ; __append(escapeFn( carouselItem.startHexColor ))
    ; __append(", #")
    ; __append(escapeFn( carouselItem.endHexColor ))
    ; __append(")\">\n                \n                    ")
    ; __line = 371
    ;  if (carouselItem.scheduleBadge) { 
    ; __append("\n                        <div class=\"schedule-badge\">\n                            ")
    ; __line = 373
    ;  if (carouselItem.isListingLive) { 
    ; __append("\n                                <span class=\"live-badge\" ")
    ; __line = 374
    ;  if (navigator.userAgent.indexOf('Win') != -1) { 
    ; __append(" style=\"margin-top: 0px\" ")
    ;  } 
    ; __append(" ></span>\n                                <span class=\"badge-copy\" ")
    ; __line = 375
    ;  if (navigator.userAgent.indexOf('Win') != -1) { 
    ; __append(" style=\"padding-bottom: 2px\" ")
    ;  } 
    ; __append(" >")
    ; __append(escapeFn( getLocale('live') ))
    ; __append("</span>\n                            ")
    ; __line = 376
    ;  } else { 
    ; __append("\n                                <span class=\"badge-copy\" ")
    ; __line = 377
    ;  if (navigator.userAgent.indexOf('Win') != -1) { 
    ; __append(" style=\"padding-bottom: 2px\" ")
    ;  } 
    ; __append(" >")
    ; __append(escapeFn( carouselItem.scheduleBadgeText ))
    ; __append("</span>\n                            ")
    ; __line = 378
    ;  } 
    ; __append("\n                        </div>\n                    ")
    ; __line = 380
    ;  } 
    ; __append("\n                \n                    <!-- Promo Tile -->\n                    ")
    ; __line = 383
    ;  if (carouselItem.promoTile) { 
    ; __append("\n                        <div class=\"promoInfo\">\n                            ")
    ; __line = 385
    ;  if (carouselItem.ctaLine1) { 
    ; __append("\n                                <div class=\"promoIcon\">\n                                    <img  src=\"")
    ; __line = 387
    ; __append(escapeFn( carouselItem.promoIcon ))
    ; __append("\" >\n                                </div>\n                            ")
    ; __line = 389
    ;  } 
    ; __append("\n                            ")
    ; __line = 390
    ;  if (carouselItem.ctaLine1) { 
    ; __append("\n                                <div class=\"promoCTALine1\">")
    ; __line = 391
    ; __append(escapeFn( carouselItem.ctaLine1 ))
    ; __append("</div>\n                            ")
    ; __line = 392
    ;  } 
    ; __append("\n                            ")
    ; __line = 393
    ;  if (carouselItem.ctaLine2) { 
    ; __append("\n                                <div class=\"promoCTALine2\">")
    ; __line = 394
    ; __append(escapeFn( carouselItem.ctaLine2 ))
    ; __append("</div>\n                            ")
    ; __line = 395
    ;  } 
    ; __append("\n                        </div>\n                    ")
    ; __line = 397
    ;  } 
    ; __append("\n                \n                    ")
    ; __line = 399
    ;  if (typeof editable !== 'undefined') { 
    ; __append("\n                        <label class=\"edit-container\">\n                            <input  type=\"checkbox\"\n                                    name=\"editor\"\n                            ")
    ; __line = 403
    ;  if(carouselItem.showId) { 
    ; __append("\n                                value=\"")
    ; __line = 404
    ; __append(escapeFn( carouselItem.showId ))
    ; __append("/")
    ; __append(escapeFn(carouselItem.showSeriesId))
    ; __append("|")
    ; __append(escapeFn(carouselItem.showSeriesTitle))
    ; __append("|")
    ; __append(escapeFn(carouselItem.showGenre))
    ; __append("|")
    ; __append(escapeFn(carouselItem.showDayPart))
    ; __append("|")
    ; __append(escapeFn(carouselItem.showEpisodeId))
    ; __append("|")
    ; __append(escapeFn(carouselItem.showEpisodeLabel))
    ; __append("|")
    ; __append(escapeFn(carouselItem.showSeasonNumber))
    ; __append("|")
    ; __append(escapeFn(carouselItem.showEpisodeNumber))
    ; __append("|")
    ; __append(escapeFn(carouselItem.showAirDate))
    ; __append("|")
    ; __append(escapeFn(carouselItem.contentId))
    ; __append("\"\n                            ")
    ; __line = 405
    ;  } 
    ; __append("                >\n                            <span class=\"checkmark\"  ></span>\n                            <div class=\"overlay\" ></div>\n                        </label>\n                    ")
    ; __line = 409
    ;  } 
    ; __append("\n                \n                    ")
    ; __line = 411
    ;  if(!carouselItem.characterImage) { 
    ; __append("\n                        <img class=\"thumb lazy ")
    ; __line = 412
    ;  if(!carouselItem.addToMyListContentId) { 
    ; __append(" without-addToMyList ")
    ;  } 
    ; __append("\"\n                        ")
    ; __line = 413
    ;  if(carouselItem.thumb) { 
    ; __append("\n                            data-src=\"")
    ; __line = 414
    ; __append(escapeFn( carouselItem.thumb ))
    ; __append("\"\n                        ")
    ; __line = 415
    ;  } 
    ; __append("\n                        ")
    ; __line = 416
    ;  if(carouselItem.alt) { 
    ; __append("\n                            alt=\"")
    ; __line = 417
    ; __append(escapeFn( carouselItem.alt ))
    ; __append("\"\n                        ")
    ; __line = 418
    ;  } 
    ; __append("\n                        >\n                    ")
    ; __line = 420
    ;  } 
    ; __append("\n                \n                    ")
    ; __line = 422
    ; // Progress Bar 

    ; __append("\n                    ")
    ; __line = 423
    ;  if(carouselItem.progress && carouselItem.progress > 0 && !carouselItem.isLive) { 
    ; __append("\n                        ")
    ; __line = 424
    ; 
                        var progress = carouselItem.progress;
                        
    ; __line = 426
    ; __append("\n                        ")
    ; __line = 427
    ; __append("\n")
    ; __line = 428
    ; __append("\n")
    ; __line = 429
    ; __append("\n")
    ; __line = 430
    ; __append("\n")
    ; __line = 431
    ;  if (typeof _uuid !== 'undefined' && typeof progress !== 'undefined') { 
    ; __append("\n<style>\n\n    #progress-bar-")
    ; __line = 434
    ; __append(escapeFn( _uuid ))
    ; __append(" {\n        width: 100%;\n        height: 4px;\n        border-radius: 10px;\n        background-color: rgba(255, 255, 255, 0.5);\n    }\n\n    #progress-bar-")
    ; __line = 441
    ; __append(escapeFn( _uuid ))
    ; __append(" .bar {\n        background-color: transparent;\n        background-image: -webkit-linear-gradient(135deg, #FFFFFF, #FFFFFF);\n        background-image: linear-gradient(135deg, #FFFFFF, #FFFFFF);\n        height: 4px;\n        border-radius: 10px 0 0 10px;\n        width: 0;\n\n        -webkit-animation: slideProgress-")
    ; __line = 449
    ; __append(escapeFn( _uuid ))
    ; __append(" ease-in 1;\n        call our keyframe named fadeIn, use animattion ease-in and repeat it only 1 time\n        -moz-animation: slideProgress-")
    ; __line = 451
    ; __append(escapeFn( _uuid ))
    ; __append(" ease-in 1;\n        animation: slideProgress-")
    ; __line = 452
    ; __append(escapeFn( _uuid ))
    ; __append(" ease-in 1s;\n        -webkit-animation-fill-mode: forwards;\n\n        ")
    ; __line = 455
    ; __append("\n        -moz-animation-fill-mode: forwards;\n        animation-fill-mode: forwards;\n        -webkit-animation-duration: 2s;\n        -moz-animation-duration: 2s;\n        animation-duration: 2s;\n    }\n\n    #progress-bar-")
    ; __line = 463
    ; __append(escapeFn( _uuid ))
    ; __append(" .bar.hasRendered {\n        -webkit-animation-duration: 0s;\n        -moz-animation-duration: 0s;\n        animation-duration: 0s;\n    }\n\n    @-webkit-keyframes slideProgress-")
    ; __line = 469
    ; __append(escapeFn( _uuid ))
    ; __append(" {\n        from {\n            width: 0;}\n\n        to {\n            width: ")
    ; __line = 474
    ; __append(escapeFn( progress ))
    ; __append("%;\n        }\n    }\n\n    @-moz-keyframes slideProgress-")
    ; __line = 478
    ; __append(escapeFn( _uuid ))
    ; __append(" {\n        from {\n            width: 0;\n        }\n        to {\n            width: ")
    ; __line = 483
    ; __append(escapeFn( progress ))
    ; __append("%;\n        }\n    }\n\n    @keyframes slideProgress-")
    ; __line = 487
    ; __append(escapeFn( _uuid ))
    ; __append(" {\n        from {\n            width: 0;\n        }\n        to {\n            width: ")
    ; __line = 492
    ; __append(escapeFn( progress ))
    ; __append("%;\n        }\n    }\n\n</style>\n\n<div class=\"progress-bar\" id=\"progress-bar-")
    ; __line = 498
    ; __append(escapeFn( _uuid ))
    ; __append("\" data-percentage=\"")
    ; __append(escapeFn( progress ))
    ; __append("\">\n    <div class=\"bar")
    ; __line = 499
    ;  if (typeof hasRendered !== 'undefined' && hasRendered) { 
    ; __append(" hasRendered ")
    ;  } 
    ; __append("\"></div>\n</div>\n")
    ; __line = 501
    ;  } 
    ; __append("\n                    ")
    ; __line = 502
    ;  } 
    ; __append("\n                \n                    ")
    ; __line = 504
    ;  if(carouselItem.characterImage) { 
    ; __append("\n                        <img class=\"thumb lazy character-img\" data-src=\"")
    ; __line = 505
    ; __append(escapeFn( carouselItem.characterImage ))
    ; __append("\" src=\"")
    ; __append(escapeFn( carouselItem.characterImage ))
    ; __append("\" alt=\"")
    ; __append(escapeFn( carouselItem.title ))
    ; __append("\">\n                    ")
    ; __line = 506
    ;  } 
    ; __append("\n                \n                    ")
    ; __line = 508
    ;  if(carouselItem.background) { 
    ; __append("\n                        <img class=\"brand-bkgd-static\" src=\"")
    ; __line = 509
    ; __append(escapeFn( carouselItem.background ))
    ; __append("\" ")
    ;  if(carouselItem.fallbackBackground) { 
    ; __append("onerror=\"this.onerror=null; this.src='")
    ; __append(escapeFn( carouselItem.fallbackBackground ))
    ; __append("'\"")
    ;  } 
    ; __append(">\n                    ")
    ; __line = 510
    ;  } 
    ; __append("\n                \n                    ")
    ; __line = 512
    ;  if(carouselItem.brandLogo) { 
    ; __append("\n                        <div class=\"brandLogo ")
    ; __line = 513
    ; __append(escapeFn( carouselItem.slug ))
    ; __append("\">\n                            <img data-src=\"")
    ; __line = 514
    ; __append(escapeFn( carouselItem.brandLogo ))
    ; __append("\" src=\"")
    ; __append(escapeFn( carouselItem.brandLogo ))
    ; __append("\" alt=\"")
    ; __append(escapeFn( carouselItem.title ))
    ; __append("\">\n                        </div>\n                    ")
    ; __line = 516
    ;  } 
    ; __append("\n                \n                    ")
    ; __line = 518
    ;  if(carouselItem.isUserSubscriber && carouselItem.bundleLocked) { 
    ; __append("\n                        <div class=\"")
    ; __line = 519
    ; __append(escapeFn( carouselItem.lockGradientClass ))
    ; __append("\"></div>\n                    ")
    ; __line = 520
    ;  } 
    ; __append("\n                \n                    ")
    ; __line = 522
    ;  if (carouselItem.isUserSubscriber && !carouselItem.isUserRegistered && !carouselItem.addToMyListContentId && (carouselItem.locked || carouselItem.bundleLocked)) { 
    ; __append("\n                        ")
    ; __line = 523
    ;  if (!carouselItem.onNowTitle) { 
    ; __append("\n                            <div class=\"label ")
    ; __line = 524
    ; __append(escapeFn( carouselItem.lockIconClass ))
    ; __append("\"><img src=\"")
    ; __append(escapeFn( carouselItem.lockIcon ))
    ; __append("\"/></div>\n                        ")
    ; __line = 525
    ;  } 
    ; __append("\n                    ")
    ; __line = 526
    ;  } else if(carouselItem.icon) { 
    ; __append("\n                        <div class=\"label ")
    ; __line = 527
    ; __append(escapeFn( carouselItem.icon ))
    ; __append(" circle-sm\"></div>\n                    ")
    ; __line = 528
    ;  } else if(carouselItem.status === 'PREMIUM' && !carouselItem.isUserSubscriber) { 
    ; __append("\n                        <div class=\"subscribe-gradient\"></div>\n                        ")
    ; __line = 530
    ;  if (typeof kidsContentLabel === "undefined" || kidsContentLabel === null) { 
    ; __append("\n                            <div class=\"label subscribe\">")
    ; __line = 531
    ; __append(escapeFn( getLocale('subscribe') ))
    ; __append("</div>\n                        ")
    ; __line = 532
    ;  } else { 
    ; __append("\n                            <div class=\"label subscribe\">")
    ; __line = 533
    ; __append(escapeFn( kidsContentLabel ))
    ; __append("</div>\n                        ")
    ; __line = 534
    ;  } 
    ; __append("\n                    ")
    ; __line = 535
    ;  } else if(carouselItem.status === 'AVAILABLE') { 
    ; __append("\n                        <div class=\"play label circle-sm\">\n                            ")
    ; __line = 537
    ;  if(carouselItem.content_id) { 
    ; __append("\n                                <svg class=\"svg-loader\" viewbox=\"0 0 33.83098862 33.83098862\" width=\"30\" height=\"30\"\n                                     xmlns=\"http://www.w3.org/2000/svg\">\n                                    <circle class=\"svg-loader__circle\" stroke=\"#FFFFFF\" stroke-width=\"2\" stroke-dasharray=\"100\" fill=\"none\"\n                                            cx=\"16.91549431\" cy=\"16.91549431\" r=\"15.91549431\"/>\n                                </svg>\n                            ")
    ; __line = 543
    ;  } 
    ; __append("\n                        </div>\n                    ")
    ; __line = 545
    ;  } 
    ; __append("\n                \n                    ")
    ; __line = 547
    ;  if(carouselItem.addToMyListContentId) { 
    ; __append("\n                        <div class=\"watchlist-bundle\">\n                            ")
    ; __line = 549
    ;  if (carouselItem.locked || carouselItem.bundleLocked){ 
    ; __append("\n                                <div class=\"watchlist-bundle__lock-gradient\"></div>\n                                <div class=\"watchlist-bundle__lock-icon\">\n                                    <img class=\"watchlist-bundle__lock-icon-img\" src=\"")
    ; __line = 552
    ; __append(escapeFn( carouselItem.lockIcon ))
    ; __append("\"/>\n                                </div>\n                            ")
    ; __line = 554
    ;  } 
    ; __append("\n                        </div>\n                    ")
    ; __line = 556
    ;  } else { 
    ; __append("\n                        ")
    ; __line = 557
    ;  if(carouselItem.onNowTitle) { 
    ; __append("\n                            <div class=\"onnow-wrapper\">\n                                <div class=\"onnow-wrapper-inside\">\n                                    <div class=\"channel-logo\">\n                                        ")
    ; __line = 561
    ;  if (carouselItem.channelLogo) { 
    ; __append("\n                                            <img src=\"")
    ; __line = 562
    ; __append(escapeFn( carouselItem.channelLogo ))
    ; __append("\">\n                                        ")
    ; __line = 563
    ;  } 
    ; __append("\n                                    </div>\n                                    ")
    ; __line = 565
    ;  if ( ((carouselItem.locked || carouselItem.bundleLocked) && carouselItem.isUserSubscriber) || (carouselItem.isLocal && carouselItem.lockIcon && !carouselItem.isUserSubscriber) ) { 
    ; __append("\n                                    <div class=\"")
    ; __line = 566
    ; __append(escapeFn( carouselItem.lockGradientClass ))
    ; __append("\"></div>\n                                    <div class=\"label ")
    ; __line = 567
    ; __append(escapeFn( carouselItem.lockIconClass ))
    ; __append("\">\n                                        <img src=\"")
    ; __line = 568
    ; __append(escapeFn( carouselItem.lockIcon ))
    ; __append("\"/>\n                                    </div>\n                                    ")
    ; __line = 570
    ;  } 
    ; __append("\n                                </div>\n                            </div>\n                        ")
    ; __line = 573
    ;  } 
    ; __append("\n                    ")
    ; __line = 574
    ;  } 
    ; __append("\n                \n                    ")
    ; __line = 576
    ;  if (carouselItem.ratingIcon && !CBS.Registry.region.international){ 
    ; __append("\n                        <img class=\"ratings-icon\" src=\"")
    ; __line = 577
    ; __append(escapeFn( carouselItem.ratingIcon ))
    ; __append("\" alt=\"")
    ; __append(escapeFn( carouselItem.ratingText ))
    ; __append("\" />\n                    ")
    ; __line = 578
    ;  } 
    ; __append("\n                    ")
    ; __line = 579
    ;  if (carouselItem.badgeLabel && !carouselItem.hasNumberLabel){ 
    ; __append("\n                        <div class=\"new-item-container\">\n                            <div class=\"new-item\">")
    ; __line = 581
    ; __append(escapeFn( carouselItem.badgeLabel ))
    ; __append("</div>\n                        </div>\n                    ")
    ; __line = 583
    ;  } 
    ; __append("\n                \n                    \n                    ")
    ; __line = 586
    ;  if(carouselItem.addToMyListContentId) { 
    ; __append("\n                        <div class=\"watchlist_wrapper initialized\"\n                             data-content-type=\"")
    ; __line = 588
    ; __append(escapeFn( carouselItem.addToMyListContentType ))
    ; __append("\"\n                             data-content-id=\"")
    ; __line = 589
    ; __append(escapeFn( carouselItem.addToMyListContentId ))
    ; __append("\" >\n                            <div class=\"watchlistCta ")
    ; __line = 590
    ; __append(escapeFn( carouselItem.inMyListClass ))
    ; __append("\">\n                                <span class=\"watchlist_copy\"></span>\n                            </div>\n                            <span class=\"tooltip\">&nbsp;</span>\n                        </div>\n                    ")
    ; __line = 595
    ;  } 
    ; __append("\n                </div>\n                \n                ")
    ; __line = 598
    ;  //START A/B TEST PLGRWEB-1558 Live Sports Data Carousel 

    ; __append("\n                ")
    ; __line = 599
    ;  if (carouselItem.gameData) { 
    ; __append("\n                    <div id=\"game-")
    ; __line = 600
    ; __append(escapeFn( carouselItem.gameData.id ))
    ; __append("\"\n                         class=\"info-wrapper sports-data-wrapper\"\n                         data-gameId=\"")
    ; __line = 602
    ; __append(escapeFn( carouselItem.gameData.id ))
    ; __append("\"\n                         data-updateLive=\"")
    ; __line = 603
    ; __append(escapeFn( carouselItem.gameData.updateLive ))
    ; __append("\">\n                        <div class=\"sports-inner-wrapper\">\n                            <div class=\"info-onnow-wrapper\">\n                                <div class=\"runTime noDescription\">\n                                    <span class=\"meta-gray title-label\">")
    ; __line = 607
    ; __append(escapeFn( carouselItem.gameData.leagueName ))
    ; __append("</span>\n                                    ")
    ; __line = 608
    ;  if (carouselItem.gameData.score) { 
    ; __append("\n                                        <span class=\"game-time-elapsed meta-gray\" data-gameTime=\"")
    ; __line = 609
    ; __append(escapeFn( carouselItem.gameData.score.gameTimeDisplayText ))
    ; __append("\">\n                                            ")
    ; __line = 610
    ; __append(escapeFn( carouselItem.gameData.score.gameTimeDisplayText ))
    ; __append("\n                                        </span>\n                                    ")
    ; __line = 612
    ;  } 
    ; __append("\n                                </div>\n                            </div>\n                            ")
    ; __line = 615
    ;  if ((carouselItem.gameData.homeTeam) && carouselItem.gameData.awayTeam) { 
    ; __append("\n                                <div class=\"teams-wrapper ")
    ; __line = 616
    ; __append(escapeFn( carouselItem.gameData.reverseOrder ))
    ; __append("\">\n                                    <div class=\"team-wrapper\">\n                                        <img class=\"team-logo\" src=\"")
    ; __line = 618
    ; __append(escapeFn( carouselItem.gameData.homeTeam.teamAssets.logoSvg ))
    ; __append("\" />\n                                        <span class=\"team-name title-label\">")
    ; __line = 619
    ; __append(escapeFn( carouselItem.gameData.homeTeam.mediumName ))
    ; __append("</span>\n                                        ")
    ; __line = 620
    ;  if (carouselItem.gameData.score) { 
    ; __append("\n                                            <span class=\"team-score home\" data-teamScore=\"")
    ; __line = 621
    ; __append(escapeFn( carouselItem.gameData.score.homeTeamScore ))
    ; __append("\">-</span>\n                                        ")
    ; __line = 622
    ;  } 
    ; __append("\n                                    </div>\n                                    <div class=\"team-wrapper\">\n                                        <img class=\"team-logo\" src=\"")
    ; __line = 625
    ; __append(escapeFn( carouselItem.gameData.awayTeam.teamAssets.logoSvg ))
    ; __append("\" />\n                                        <span class=\"team-name title-label\">")
    ; __line = 626
    ; __append(escapeFn( carouselItem.gameData.awayTeam.mediumName ))
    ; __append("</span>\n                                        ")
    ; __line = 627
    ;  if (carouselItem.gameData.score) { 
    ; __append("\n                                            <span class=\"team-score away\" data-teamScore=\"")
    ; __line = 628
    ; __append(escapeFn( carouselItem.gameData.score.awayTeamScore ))
    ; __append("\">-</span>\n                                        ")
    ; __line = 629
    ;  } 
    ; __append("\n                                    </div>\n                                </div>\n                            ")
    ; __line = 632
    ;  } 
    ; __append("\n                        </div>\n                    </div>\n                ")
    ; __line = 635
    ;  } else { 
    ; __append("\n                    ")
    ; __line = 636
    ;  //END A/B TEST PLGRWEB-1558 Live Sports Data Carousel 

    ; __append("\n                \n                    <div class=\"info-wrapper\">\n                        ")
    ; __line = 639
    ;  if(carouselItem.onNowTitle) { 
    ; __append("\n                            <div class=\"info-onnow-wrapper\">\n                                <div class=\"runTime noDescription\">\n                                    ")
    ; __line = 642
    ;  if(carouselItem.seasonString) { 
    ; __append("\n                                        <span class=\"season-string\">")
    ; __line = 643
    ; __append(escapeFn( carouselItem.seasonString ))
    ; __append("</span>\n                                    ")
    ; __line = 644
    ;  } 
    ; __append("\n                                    ")
    ; __line = 645
    ;  if(carouselItem.isListingLive) { 
    ; __append("\n                                        <span class=\"meta-gray\">\n                                            ")
    ; __line = 647
    ; __append(escapeFn( carouselItem.scheduleBadgeText ))
    ; __append("\n                                        </span>\n                                    ")
    ; __line = 649
    ;  } 
    ; __append("\n                                    <span class=\"meta-gray onnow-separator\">\n                                        ·\n                                    </span>\n                                    ")
    ; __line = 653
    ;  if(carouselItem.isMultiChannel){ 
    ; __append("\n                                        <span class=\"meta-gray\">\n                                            ")
    ; __line = 655
    ; __append(escapeFn( carouselItem.multiChannelName ))
    ; __append("\n                                        </span>\n                                    ")
    ; __line = 657
    ;  } else if(carouselItem.isOnNow) { 
    ; __append("\n                                        <span class=\"meta-gray\">\n                                            ")
    ; __line = 659
    ; __append(escapeFn( carouselItem.liveTvChannel ))
    ; __append("\n                                        </span>\n                                    ")
    ; __line = 661
    ;  } else { 
    ; __append("\n                                        ")
    ; __line = 662
    ;  if(carouselItem.onNowTimeElapsed) { 
    ; __append("\n                                            <span class=\"time-details\">\n                                                ")
    ; __line = 664
    ; __append(escapeFn( carouselItem.onNowTimeElapsed ))
    ; __append("\n                                            </span>\n                                        ")
    ; __line = 666
    ;  } else if(carouselItem.onNowrunTime || carouselItem.onNowTimeRemaining) { 
    ; __append("\n                                            <span class=\"time-details\">\n                                                ")
    ; __line = 668
    ; __append(escapeFn( carouselItem.onNowrunTime ))
    ; __append(" ")
    ; __append(escapeFn(carouselItem.onNowTimeRemaining ))
    ; __append("\n                                            </span>\n                                        ")
    ; __line = 670
    ;  } 
    ; __append("\n                                    ")
    ; __line = 671
    ;  } 
    ; __append("\n                                </div>\n                                <div class=\"title-wrapper\">\n                                    <div class=\"on-title\" data-title=\"")
    ; __line = 674
    ; __append(escapeFn( carouselItem.onNowTitle ))
    ; __append("\">\n                                        ")
    ; __line = 675
    ; __append(escapeFn( carouselItem.onNowTitle ))
    ; __append("\n                                    </div>\n                                </div>\n                            </div>\n                        ")
    ; __line = 679
    ;  omitTitle = true; 
    ; __append("\n                        ")
    ; __line = 680
    ;  } 
    ; __append("\n                    \n                        ")
    ; __line = 682
    ;  if(carouselItem.whatsNew && contentType) { 
    ; __append("\n                            <span class=\"meta-category\">\n                                ")
    ; __line = 684
    ; __append(escapeFn( contentType ))
    ; __append("\n                            </span>\n                        ")
    ; __line = 686
    ;  } 
    ; __append("\n                    \n                        ")
    ; __line = 688
    ; // META DATA (Watchagain carousel show) 

    ; __append("\n                        ")
    ; __line = 689
    ;  if(carouselItem.watchAgainCarouselContentType === 'show') { 
    ; __append("\n                            <span class='meta-watch-again-wrapper'>\n                                ")
    ; __line = 691
    ;  if(!carouselItem.isSeasonless && !carouselItem.showSeasonless && carouselItem.seasonNumber) { 
    ; __append("\n                                    <span class=\"meta-white ")
    ; __line = 692
    ; __append(escapeFn( carouselItem.metaSeasonNumberClass ))
    ; __append("\">\n                                        <abbr aria-label=\"Season ")
    ; __line = 693
    ; __append(escapeFn( carouselItem.seasonNumber ))
    ; __append("\" title=\"")
    ; __append(escapeFn( getLocale('season') ))
    ; __append(" ")
    ; __append(escapeFn( carouselItem.seasonNumber ))
    ; __append("\">\n                                            ")
    ; __line = 694
    ; __append(escapeFn( getLocale('season_number_abbr', {'seasonNumber': carouselItem.seasonNumber }) ))
    ; __append("\n                                        </abbr>\n                                    </span>\n                                ")
    ; __line = 697
    ;  } 
    ; __append("\n                                ")
    ; __line = 698
    ;  if(!carouselItem.isEpisodeless && !carouselItem.showEpisodeless && carouselItem.episodeNumber) { 
    ; __append("\n                                    <span class=\"meta-white ")
    ; __line = 699
    ; __append(escapeFn( carouselItem.metaEpisodeNumberClass ))
    ; __append("\">\n                                        <abbr aria-label=\"Episode ")
    ; __line = 700
    ; __append(escapeFn( carouselItem.episodeNumber ))
    ; __append("\" title=\"")
    ; __append(escapeFn( getLocale('episode') ))
    ; __append(" ")
    ; __append(escapeFn( carouselItem.episodeNumber ))
    ; __append("\">\n                                            ")
    ; __line = 701
    ; __append(escapeFn( getLocale('episode_number_abbr', {'episodeNum': carouselItem.episodeNumber }) ))
    ; __append("\n                                        </abbr>\n                                    </span>\n                                ")
    ; __line = 704
    ;  } 
    ; __append("\n                                ")
    ; __line = 705
    ;  if(carouselItem.episodeOrClipTitle) { 
    ; __append("\n                                    <span class=\"meta-gray meta-episode-title\">\n                                        ")
    ; __line = 707
    ; __append(escapeFn( carouselItem.episodeOrClipTitle ))
    ; __append("\n                                    </span>\n                                ")
    ; __line = 709
    ;  } 
    ; __append("\n                            </span>\n                        ")
    ; __line = 711
    ;  } 
    ; __append("\n                        \n                        <div class=\"meta-gray-wrapper title-shorten\">\n                            \n                        ")
    ; __line = 715
    ; // META DATA (Watchagain carousel movie) 

    ; __append("\n                        ")
    ; __line = 716
    ;  if(carouselItem.watchAgainCarouselContentType === 'movie') { 
    ; __append("\n                            <span class=\"meta-gray meta-airdate ")
    ; __line = 717
    ; __append(escapeFn( carouselItem.startDateISOClass ))
    ; __append("\">\n                                <time datetime=\"")
    ; __line = 718
    ; __append(escapeFn( carouselItem.startDateISO ))
    ; __append("\">\n                                    ")
    ; __line = 719
    ; __append(escapeFn( carouselItem.startDate ))
    ; __append("\n                                </time>\n                            </span>\n                        ")
    ; __line = 722
    ;  } 
    ; __append("\n                    \n                        ")
    ; __line = 724
    ; // META DATA (show) 

    ; __append("\n                        ")
    ; __line = 725
    ;  if(!carouselItem.isMovie && !carouselItem.watchAgainCarouselContentType) { 
    ; __append("\n                            ")
    ; __line = 726
    ;  if(carouselItem.content_type !== "Clip") { 
    ; __append("\n                                ")
    ; __line = 727
    ;  if(!carouselItem.isSeasonless && !carouselItem.showSeasonless && carouselItem.seasonNumber) { 
    ; __append("\n                                    <span class=\"meta-white  ")
    ; __line = 728
    ;  if(CBS.Registry.Features.web_episode_descriptions_enabled) { 
    ; __append("season-inline")
    ;  } 
    ; __append("\">\n                                        <abbr class=\"")
    ; __line = 729
    ;  if(CBS.Registry.Features.web_episode_descriptions_enabled) { 
    ; __append("season-inline")
    ;  } 
    ; __append("\" aria-label=\"Season ")
    ; __append(escapeFn( carouselItem.seasonNumber ))
    ; __append("\" title=\"")
    ; __append(escapeFn( getLocale('season') ))
    ; __append(" ")
    ; __append(escapeFn( carouselItem.seasonNumber ))
    ; __append("\">\n                                            ")
    ; __line = 730
    ; __append(escapeFn( getLocale('season_number_abbr', {'seasonNumber': carouselItem.seasonNumber }) ))
    ; __append("\n                                        </abbr>\n                                    </span>\n                                ")
    ; __line = 733
    ;  } 
    ; __append("\n                                ")
    ; __line = 734
    ;  if(!carouselItem.isEpisodeless && !carouselItem.showEpisodeless && carouselItem.episodeNumber) { 
    ; __append("\n                                    <span class=\"meta-white ")
    ; __line = 735
    ;  if(CBS.Registry.Features.web_episode_descriptions_enabled) { 
    ; __append("season-inline")
    ;  } 
    ; __append("\">\n                                        <abbr class=\"")
    ; __line = 736
    ;  if(CBS.Registry.Features.web_episode_descriptions_enabled) { 
    ; __append("season-inline")
    ;  } 
    ; __append("\" aria-label=\"Episode ")
    ; __append(escapeFn( carouselItem.episodeNumber ))
    ; __append("\" title=\"")
    ; __append(escapeFn( getLocale('episode') ))
    ; __append(" ")
    ; __append(escapeFn( carouselItem.episodeNumber ))
    ; __append("\">\n                                            ")
    ; __line = 737
    ; __append(escapeFn( getLocale('episode_number_abbr', {'episodeNum': carouselItem.episodeNumber }) ))
    ; __append("\n                                        </abbr>\n                                    </span>\n                                ")
    ; __line = 740
    ;  } 
    ; __append("\n\n\n                                ")
    ; __line = 743
    ;  if(CBS.Registry.pageType !== 'movies' && CBS.Registry.pageType !== 'HOMEPAGE' && carouselItem.brand !== 'CBS News' && CBS.Registry.Features.web_episode_descriptions_enabled && carouselItem.title && omitTitle === false && carouselItem.whatsNew !== true) { 
    ; __append("\n                                    ")
    ; __line = 744
    ; __append(escapeFn( carouselItem.title ))
    ; __append("\n                                    ")
    ; __line = 745
    ;  omitTitle = true; 
    ; __append("\n                                    ")
    ; __line = 746
    ;  showDuration = true; 
    ; __append("\n                                ")
    ; __line = 747
    ;  } 
    ; __append("\n                            \n                            \n                            \n                            \n                                ")
    ; __line = 752
    ;  if(CBS.Registry.pageType !== 'movies' ) { 
    ; __append("\n                                    ")
    ; __line = 753
    ;  if(!carouselItem.isNewsTopStories && carouselItem.airDate !== 0 && (!CBS.Registry.Features.web_episode_descriptions_enabled || carouselItem.carouselType === 'keep-watching')) { 
    ; __append("\n                                        <span class=\"meta-gray meta-airdate ")
    ; __line = 754
    ; __append(escapeFn( carouselItem.startDateISOClass ))
    ; __append("\">\n                                            <time datetime=\"")
    ; __line = 755
    ; __append(escapeFn( carouselItem.startDateISO ))
    ; __append("\">\n                                                ")
    ; __line = 756
    ; __append(escapeFn( carouselItem.startDate ))
    ; __append("\n                                            </time>\n                                        </span>\n                                    ")
    ; __line = 759
    ;  } else if(carouselItem.mediaType !== "Clip" && (CBS.Registry.Features.web_episode_descriptions_enabled && omitTitle === false && carouselItem.whatsNew !== true && carouselItem.isNewsTopStories === false)) { 
    ; __append("\n                                        ")
    ; __line = 760
    ;  omitTitle = true; 
    ; __append("\n                                        <span class=\"title-wrapper\">\n                                            <span class=\"title title-inline\" data-title=\"")
    ; __line = 762
    ; __append(escapeFn( carouselItem.title ))
    ; __append("\">\n                                                ")
    ; __line = 763
    ;  if(displayShowTitle && carouselItem.seriesTitle) { 
    ; __append("\n                                                ")
    ; __line = 764
    ; __append(escapeFn( carouselItem.seriesTitle ))
    ; __append(" |\n                                                ")
    ; __line = 765
    ;  } 
    ; __append("\n                                                ")
    ; __line = 766
    ; __append(escapeFn( carouselItem.title ))
    ; __append("\n                                            </span>\n                                        </span>\n                                    ")
    ; __line = 769
    ;  } 
    ; __append("\n                                ")
    ; __line = 770
    ;  } 
    ; __append("\n                            ")
    ; __line = 771
    ;  } 
    ; __append("\n                        ")
    ; __line = 772
    ;  } 
    ; __append("\n                    \n                        ")
    ; __line = 774
    ; // META DATA (newsTopStories) 

    ; __append("\n                        ")
    ; __line = 775
    ;  if(carouselItem.isNewsTopStories && carouselItem.startDate) { 
    ; __append("\n                            <span class=\"meta-gray meta-airdate\">\n                                <time datetime=\"")
    ; __line = 777
    ; __append(escapeFn( carouselItem.startDateISO ))
    ; __append("\">\n                                    ")
    ; __line = 778
    ; __append(escapeFn( carouselItem.startDate ))
    ; __append("\n                                </time>\n                            </span>\n                        ")
    ; __line = 781
    ;  } 
    ; __append("\n                    \n                        ")
    ; __line = 783
    ; // FOR NOMINEE USE ONLY 

    ; __append("\n                        ")
    ; __line = 784
    ;  if(carouselItem.winner) { 
    ; __append("\n                            <span class=\"nom-winner\">\n                                <img class=\"thumb lazy\" data-src=\"")
    ; __line = 786
    ; __append(escapeFn( carouselItem.winner_icon ))
    ; __append("\" alt=\"Winner\" title=\"Winner\" />\n                            </span>\n                        ")
    ; __line = 788
    ;  } 
    ; __append("\n                        \n                        ")
    ; __line = 790
    ; // DURATION 

    ; __append("\n                        ")
    ; __line = 791
    ;  if(!CBS.Registry.Features.web_episode_descriptions_enabled) { 
    ; __append("\n                            ")
    ; __line = 792
    ;  if(!carouselItem.isMovie && carouselItem.duration && !carouselItem.onNowTitle && carouselItem.displayItemTitle && carouselItem.mediaType !== "Full Episode"){ 
    ; __append("\n                                <span class=\"meta-gray\">\n                                    ")
    ; __line = 794
    ; __append(escapeFn( carouselItem.duration ))
    ; __append("\n                                </span>\n                            ")
    ; __line = 796
    ;  } 
    ; __append("\n                        ")
    ; __line = 797
    ;  } 
    ; __append("\n                    \n                        ")
    ; __line = 799
    ; // CHARACTER NAME 

    ; __append("\n                        ")
    ; __line = 800
    ;  if(carouselItem.characterName){ 
    ; __append("\n                            <span class=\"meta-gray\">\n                                ")
    ; __line = 802
    ; __append(escapeFn( carouselItem.characterName ))
    ; __append("\n                            </span>\n                        ")
    ; __line = 804
    ;  } 
    ; __append("\n                    \n                        ")
    ; __line = 806
    ; // LIVE TV SCHEDULE START TIME 

    ; __append("\n                        ")
    ; __line = 807
    ;  if(carouselItem.startTime){ 
    ; __append("\n                            <div class=\"startTime-wrapper\">\n                                <div class=\"startTime\">\n                                    ")
    ; __line = 810
    ; __append(escapeFn( carouselItem.startTime ))
    ; __append("\n                                </div>\n                                ")
    ; __line = 812
    ;  if(i == 0){ 
    ; __append("\n                                    <div class=\"liveNow\"><div class=\"blue-dot blinking\"></div> LIVE</div>\n                                ")
    ; __line = 814
    ;  } 
    ; __append("\n                            </div>\n                        ")
    ; __line = 816
    ;  } 
    ; __append("\n                    \n                    \n                        ")
    ; __line = 819
    ; // MOVIE YEAR DURATION RATING  

    ; __append("\n                        ")
    ; __line = 820
    ;  if((carouselItem.rating || carouselItem.yearMin) && contentType==='movie' && carouselItem.orientation != 'portrait'){ 
    ; __append("\n                            <span class=\"meta-gray\">\n                            ")
    ; __line = 822
    ;  if(carouselItem.yearMin){ 
    ; __append("\n                                ")
    ; __line = 823
    ; __append(escapeFn( carouselItem.yearMin ))
    ; __append("\n                            ")
    ; __line = 824
    ;  } 
    ; __append("\n                            ")
    ; __line = 825
    ;  if(carouselItem.rating && !CBS.Registry.region.international && (!CBS.Registry.Features.web_episode_descriptions_enabled || carouselItem.carouselType === 'keep-watching')){ 
    ; __append("\n                                ")
    ; __line = 826
    ; __append(escapeFn( carouselItem.rating ))
    ; __append("\n                            ")
    ; __line = 827
    ;  } 
    ; __append("\n                            </span>\n                        ")
    ; __line = 829
    ;  } 
    ; __append("\n\n                        </div>\n                    \n                        ")
    ; __line = 833
    ; // TITLE 

    ; __append("\n                        ")
    ; __line = 834
    ;  if(carouselItem.title && !carouselItem.onNowTitle && carouselItem.displayItemTitle && omitTitle === false){ 
    ; __append("\n                            <div class=\"title-wrapper\">\n                                <div class=\"title\" data-title=\"")
    ; __line = 836
    ; __append(escapeFn( carouselItem.title ))
    ; __append("\">\n                                    ")
    ; __line = 837
    ;  if(displayShowTitle && carouselItem.seriesTitle) { 
    ; __append("\n                                        ")
    ; __line = 838
    ; __append(escapeFn( carouselItem.seriesTitle ))
    ; __append(" |\n                                    ")
    ; __line = 839
    ;  } 
    ; __append("\n                                    ")
    ; __line = 840
    ; __append(escapeFn( carouselItem.title ))
    ; __append("\n                                </div>\n                            </div>\n                        ")
    ; __line = 843
    ;  omitTitle = true; 
    ; __append("\n                        ")
    ; __line = 844
    ;  } 
    ; __append("\n                    \n                        ")
    ; __line = 846
    ; // LIVE TV SCHEDULE DESCRIPTION 

    ; __append("\n                        ")
    ; __line = 847
    ;  if(carouselItem.description && CBS.Registry.Features.web_episode_descriptions_enabled){ 
    ; __append("\n                            <div class=\"description-wrapper\" id=\"js-schedule-description\">\n                                <div class=\"description limited-text\" id=\"js-schedule-copy\">\n                                    ")
    ; __line = 850
    ; __append(escapeFn( carouselItem.description ))
    ; __append("\n                                </div>\n                                <div class=\"runTime\">\n                                    ")
    ; __line = 853
    ; __append(escapeFn( carouselItem.runTime ))
    ; __append("\n                                </div>\n                            </div>\n                        ")
    ; __line = 856
    ;  } else if(carouselItem.runTime) { 
    ; __append("\n                            <div class=\"runTime noDescription\">\n                                ")
    ; __line = 858
    ; __append(escapeFn( carouselItem.runTime ))
    ; __append("\n                            </div>\n                        ")
    ; __line = 860
    ;  } 
    ; __append("\n\n                        ")
    ; __line = 862
    ;  if(CBS.Registry.Features.web_episode_descriptions_enabled && (CBS.Registry.pageType === 'movies' || omitTitle === false || (showDuration === true && carouselItem.mediaType === "Full Episode"))) { 
    ; __append("\n                            ")
    ; __line = 863
    ; __append("\n                            <span class=\"meta-gray lower-case\">\n                                ")
    ; __line = 865
    ; __append(escapeFn( carouselItem.duration ))
    ; __append("\n                            </span>\n    \n                            ")
    ; __line = 868
    ; __append("\n                            <span class=\"meta-gray ")
    ; __line = 869
    ; __append(escapeFn( carouselItem.mediaType === "Clip" ? 'meta-airdate-left' : 'meta-airdate' ))
    ; __append("\">\n                                <time datetime=\"")
    ; __line = 870
    ; __append(escapeFn( carouselItem.startDate ))
    ; __append("\">\n                                    ")
    ; __line = 871
    ; __append(escapeFn( carouselItem.startDate ))
    ; __append("\n                                </time>\n                            </span>\n                        ")
    ; __line = 874
    ;  } 
    ; __append("\n                        \n                        ")
    ; __line = 876
    ; // GUESTS APPEARANCE DATE 

    ; __append("\n                        ")
    ; __line = 877
    ;  if(carouselItem.appearanceDate){ 
    ; __append("\n                            <div class=\"guests-appearance-date\">\n                                ")
    ; __line = 879
    ; __append(escapeFn( carouselItem.appearanceDate ))
    ; __append("\n                            </div>\n                        ")
    ; __line = 881
    ;  } 
    ; __append("\n                    \n                        ")
    ; __line = 883
    ; // GUESTS 

    ; __append("\n                        ")
    ; __line = 884
    ;  if(carouselItem.guests_array){ 
    ; __append("\n                            <div class=\"guests\" id=\"guests\"></div>\n                            ")
    ; __line = 886
    ; 
                            var div = document.getElementById('guests');
                            for(var guest in carouselItem.guests_array) {
                                div.innerHTML += '<div class="guest">'+guest+'</div>';
                            }
                            
    ; __line = 891
    ; __append("\n                        ")
    ; __line = 892
    ;  } 
    ; __append("\n                    \n                    </div>\n\n                ")
    ; __line = 896
    ;  } 
    ; __append("\n\n            ")
    ; __line = 898
    ;  } 
    ; __append("\n\n        </a>\n\n        <div class=\"break\"></div>\n\n    ")
    ; __line = 904
    ;  } 
    ; __append("\n\n")
    ; __line = 906
    ;   } 
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL="node_modules/.pnpm/git@github.com+cbsi-cbscom+web-package-coreui@7d7ba8afd4bc5ca2bfaf5656bcb870d17e89ab51_fetch-_k4du5uksy5fad7om3lugymerom/node_modules/cbs-core-ui/src/js/templates/carousels/__carousel.tpl"

}